/* ==========================================================================
   JBOXLY \u00b7 Portal de centros v3.3 \u2014 assets/jbx-portal-master.js (13-oct-2026)
   v3.3: "💸 Ya te pagué" en 2 pasos (qué pedidos: entregados / por entregar;
   cuánto: total o abono; método, referencia y foto) y la cuenta por etapas:
   lo que debe ya (entregado) y lo que deberá (en su centro, en camino, en compra).
   v3.2 (12-oct): rendición desde el portal con foto; historial aprobada / rechazada.
   v3 (26-sep-2026)
   Todo el JS del portal vive aqu\u00ed, no en la secci\u00f3n (regla del fantasma de
   /en/). Backend: /api/sesion, acciones master-*.
   La sesi\u00f3n del centro sigue en sessionStorage 'jpm_ses' con el MISMO formato
   de antes, porque el buscador en modo centro (compra-en-jboxly.js) la lee.
   ========================================================================== */
(function () {
  'use strict';
  var API = 'https://jboxly-realtime-search.vercel.app/api/sesion';
  var ROOT = document.getElementById('jpm');
  if (!ROOT || ROOT.getAttribute('data-listo')) return;
  ROOT.setAttribute('data-listo', '1');
  var EMAIL = String(ROOT.getAttribute('data-email') || '').trim().toLowerCase();

  /* capas al <body>: as\u00ed ning\u00fan contenedor del tema las recorta */
  ['jpm-fondo', 'jpm-drawer', 'jpm-dlg', 'jpm-est', 'jpm-toast'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el && el.parentNode !== document.body) document.body.appendChild(el);
  });

  var ETAPAS = [
    { k: 'compra', l: 'En compra', i: '\ud83d\uded2', c: '#3b82f6', sub: 'JBOXLY los est\u00e1 comprando' },
    { k: 'camino', l: 'En camino', i: '\u2708\ufe0f', c: '#8b5cf6', sub: 'vienen a tu centro' },
    { k: 'centro', l: 'Por entregar', i: '\ud83c\udfec', c: '#ec4899', sub: 'ya est\u00e1n en tu centro' },
    { k: 'cliente', l: 'Entregados', i: '\ud83c\udfc1', c: '#22c55e', sub: 'al cliente' }
  ];
  var CANCELADA = { k: 'cancelada', l: 'Cancelados', i: '\ud83d\udeab', c: '#f87171', sub: '' };
  function etq(k) { for (var i = 0; i < ETAPAS.length; i++) if (ETAPAS[i].k === k) return ETAPAS[i]; return CANCELADA; }

  var SES = null;
  try { SES = JSON.parse(sessionStorage.getItem('jpm_ses') || 'null'); } catch (e) {}
  if (SES && !SES.codigo) SES = null;

  var P = [];          /* pedidos normalizados */
  var RES = null;      /* resumen contable del backend */
  var CARGADO = 0, CARGANDO = false;
  var S = {
    etapa: '', hoy: '', orig: 'all', pago: 'all', q: '',
    abierto: null, conf: null, editando: null, enviando: false,
    modo: 'recibir', n: 0, estAb: false, pend: null,
    buf: '', t0: 0, tU: 0, tm: null,           /* l\u00e1ser con la estaci\u00f3n abierta */
    pbuf: '', pt0: 0, ptU: 0,                  /* l\u00e1ser con la estaci\u00f3n cerrada */
    cola: [], ocupado: false, camUlt: '', camTs: 0, pendTs: 0
  };
  /* cambios que el centro acaba de hacer: se respetan ~90 s aunque la
     recarga del servidor llegue con datos de un instante antes */
  var LOCAL = {};
  function recordar(id, cambios) { LOCAL[id] = { c: cambios, ts: Date.now() }; }

  /* --------- utilidades --------- */
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function din(n) { n = Number(n) || 0; return (n < 0 ? '-$' : '$') + Math.abs(Math.round(n * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function num(s) { return parseFloat(String(s == null ? '' : s).replace(/[^0-9.]/g, '')) || 0; }
  function dias(iso) { var t = Date.parse(iso || ''); if (!t) return -1; return Math.max(0, Math.floor((Date.now() - t) / 86400000)); }
  function fcorta(iso) { var t = Date.parse(iso || ''); if (!t) return ''; try { return new Date(t).toLocaleDateString('es-VE', { day: 'numeric', month: 'short' }); } catch (e) { return String(iso).slice(0, 10); } }
  function hora() { try { return new Date().toLocaleTimeString('es-VE', { hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } }
  function primer(n) { return String(n || '').trim().split(/\s+/)[0] || 'tu cliente'; }
  function plural(n, s, p) { return n + ' ' + (n === 1 ? s : p); }
  function soloDig(s) { return String(s || '').replace(/\D/g, ''); }
  function lock(on) { document.documentElement.classList.toggle('jpm-lock', !!on); }
  function capasAbiertas() { return S.estAb || !$('jpm-dlg').hidden || !!S.abierto || !!($('jpm-rd') && !$('jpm-rd').hidden); }

  var tT;
  function toast(m) { var t = $('jpm-toast'); t.textContent = m; t.hidden = false; clearTimeout(tT); tT = setTimeout(function () { t.hidden = true; }, 3800); }

  /* --------- backend --------- */
  function api(accion, datos, sinSesion) {
    if (!sinSesion && !SES) return Promise.resolve({ ok: false, _st: 401, error: 'Sin sesi\u00f3n' });
    var body = { accion: accion };
    if (!sinSesion && SES) { body.codigo = SES.codigo; body.clave = SES.clave; }
    if (datos) Object.keys(datos).forEach(function (k) { body[k] = datos[k]; });
    var pet;
    try { pet = fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); }
    catch (e) { return Promise.reject(e); }
    return pet
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          d = d || {};
          d._st = r.status;
          if (r.status === 401 && !sinSesion) sesionVencida();
          if (r.status === 429 && !d.error) d.error = 'Demasiados intentos. Espera 10 minutos.';
          return d;
        });
      });
  }

  /* --------- datos --------- */
  function normalizar(p) {
    var cod = /contra[\s_-]?entrega/i.test(String(p.metodo || ''));
    var x = {
      id: p.idPedido || '', o: p.propio ? 'propio' : 'asig',
      cli: p.cliente || 'Sin nombre', tel: p.telefono || '', em: p.email || '', dir: p.direccion || '', nota: p.nota || '',
      met: cod ? 'cod' : 'pag', metodo: p.metodo || '', st: p.estado || '',
      tot: Number(p.total) || 0, abonado: Number(p.abonado) || 0,
      items: Array.isArray(p.productos) ? p.productos : [], fecha: p.fecha || '', caja: p.caja || '',
      com: Number(p.comision) || 0, desg: p.desglose || null, ent: p.entrega_cliente || null,
      enCentro: p.en_centro_fecha || '', tb: Number(p.bultos_total) || 1, bc: Number(p.bultos_centro) || 0,
      origen: p.origen || '',
      rendido: !!p.rendido /* v3.2: ya rendido a JBOXLY (aprobado) */
    };
    x.cobrar = x.met === 'cod' ? Math.max(0, Math.round((x.tot - x.abonado) * 100) / 100) : 0;
    return x;
  }
  function byId(id) { for (var i = 0; i < P.length; i++) if (P[i].id === id) return P[i]; return null; }
  function etapa(p) {
    if (p.ent) return 'cliente';
    if (p.st === 'cancelada') return 'cancelada';
    if (p.st === 'en-centro' || p.st === 'entregada') return 'centro';
    if (p.st === 'despachado' || p.st === 'en-camino') return 'camino';
    return 'compra';
  }
  function paso(p) {
    var e = etapa(p);
    return e === 'compra' ? (p.st === 'comprado' ? 1 : 0) : e === 'camino' ? 2 : e === 'centro' ? 3 : e === 'cliente' ? 4 : -1;
  }
  function estadoTxt(p) {
    var e = etapa(p);
    if (e === 'compra') return p.st === 'comprado' ? 'Comprado' : p.st === 'pendiente-pago-productos' ? 'Esperando pago' : 'Cargado';
    if (e === 'camino') return p.st === 'despachado' ? 'Por salir' : 'En camino';
    if (e === 'centro') return 'Por entregar';
    if (e === 'cliente') return 'Entregado';
    return 'Cancelado';
  }
  function notaDe(p) {
    var e = etapa(p);
    if (e === 'compra') return p.st === 'comprado' ? 'Comprado, viene a Dallas' : p.st === 'en-proceso' ? 'JBOXLY lo est\u00e1 comprando' : p.st === 'pendiente-pago-productos' ? 'Esperando el pago' : 'JBOXLY va a comprarlo';
    if (e === 'camino') {
      if (p.bc > 0 && p.bc < p.tb) return 'Llegaron ' + p.bc + ' de ' + p.tb + ' bultos';
      if (p.st === 'despachado') return 'Sellado, por salir' + (p.caja ? ' \u00b7 caja ' + p.caja : '');
      return p.caja ? 'En la caja ' + p.caja : 'Viajando';
    }
    if (e === 'centro') { var d = dias(p.enCentro); return d < 0 ? 'En tu centro' : d === 0 ? 'Lleg\u00f3 hoy' : 'Lleg\u00f3 hace ' + d + 'd'; }
    if (e === 'cliente') return 'Entregado el ' + fcorta(p.ent.fecha);
    return 'Pedido cancelado';
  }
  var PROM = null;
  function cargar(silencio) {
    if (!SES) return Promise.resolve();
    if (CARGANDO) { S.otraVez = true; return PROM; }
    CARGANDO = true;
    if (!silencio) $('jpm-act').textContent = 'Actualizando\u2026';
    PROM = api('master-mis-pedidos').then(function (d) {
      CARGANDO = false;
      if (!d.ok) {
        if (d._st !== 401) { $('jpm-act').textContent = 'No se pudo actualizar'; if (!P.length) $('jpm-lista').innerHTML = '<div class="jpm-list"><div class="jpm-vacio">' + esc(d.error || 'No se pudieron cargar tus pedidos.') + ' <button type="button" class="jpm-lnk" data-jpm="recargar">Reintentar</button></div></div>'; }
        return;
      }
      P = (d.pedidos || []).map(normalizar);
      var ahora = Date.now();
      Object.keys(LOCAL).forEach(function (id) {
        if (ahora - LOCAL[id].ts > 90000) { delete LOCAL[id]; return; }
        var p = byId(id); if (!p) return;
        Object.keys(LOCAL[id].c).forEach(function (k) { p[k] = LOCAL[id].c[k]; });
      });
      RES = d.resumen || {};
      REND = Array.isArray(d.rendiciones) ? d.rendiciones : [];
      CARGADO = Date.now();
      $('jpm-act').textContent = 'Actualizado ' + hora();
      pintarCabecera();
      pintar();
      if (S.otraVez) { S.otraVez = false; cargar(true); }
    }).catch(function () {
      CARGANDO = false;
      $('jpm-act').textContent = 'Sin conexi\u00f3n';
      if (!P.length) $('jpm-lista').innerHTML = '<div class="jpm-list"><div class="jpm-vacio">Sin conexi\u00f3n. <button type="button" class="jpm-lnk" data-jpm="recargar">Reintentar</button></div></div>';
    });
    return PROM;
  }

  /* --------- filtros --------- */
  function base(p) {
    if (S.orig !== 'all' && p.o !== S.orig) return false;
    if (S.pago !== 'all' && p.met !== S.pago) return false;
    if (S.q) {
      var h = norm([p.id, p.cli, p.tel, soloDig(p.tel), p.em, p.dir, p.caja].concat(p.items.map(function (x) { return x.titulo; })).join(' '));
      var ws = norm(S.q).split(/\s+/).filter(Boolean);
      for (var i = 0; i < ws.length; i++) if (h.indexOf(ws[i]) === -1) return false;
    }
    return true;
  }
  function tiempo(p) { return Date.parse(p.fecha || '') || 0; }
  function visibles() {
    var v = P.filter(function (p) {
      if (!base(p)) return false;
      var e = etapa(p);
      if (S.etapa && e !== S.etapa) return false;
      if (S.hoy === 'entregar' && e !== 'centro') return false;
      if (S.hoy === 'recibir' && e !== 'camino') return false;
      return true;
    });
    return v.sort(function (a, b) {
      if (S.hoy) return (Date.parse(a.enCentro) || tiempo(a)) - (Date.parse(b.enCentro) || tiempo(b));
      var ca = etapa(a) === 'cancelada' ? 1 : 0, cb = etapa(b) === 'cancelada' ? 1 : 0;
      if (ca !== cb) return ca - cb;
      return tiempo(b) - tiempo(a);
    });
  }

  /* --------- pintar --------- */
  function pintarCabecera() {
    if (!SES) return;
    $('jpm-nombre').textContent = SES.nombre || 'Centro';
    var sub = [SES.codigo, SES.ciudad].filter(Boolean).join(' \u00b7 ');
    if (RES && RES.comision_tope) sub += ' \u00b7 comisi\u00f3n ' + (RES.comision_pct || 10) + '% (tope ' + din(RES.comision_tope) + ') por entrega';
    $('jpm-sub').textContent = sub;
    $('jpm-est-s').textContent = 'Esc\u00e1ner del centro \u00b7 ' + (SES.nombre || '');
  }
  function pintarPipe() {
    var b = P.filter(base);
    $('jpm-pipe').innerHTML = ETAPAS.map(function (e) {
      var arr = b.filter(function (p) { return etapa(p) === e.k; });
      var sub = e.sub;
      if (e.k === 'camino') { var cj = {}; arr.forEach(function (p) { if (p.caja) cj[p.caja] = 1; }); var n = Object.keys(cj).length; if (n) sub = plural(n, 'caja en camino', 'cajas en camino'); }
      if (e.k === 'centro' && arr.length) sub = plural(arr.length, 'cliente esperando', 'clientes esperando');
      var on = S.etapa === e.k;
      return '<button type="button" class="jpm-stg' + (on ? ' on' : '') + (arr.length ? '' : ' cero') + '" data-jpm="etapa" data-k="' + e.k + '" aria-pressed="' + on + '" style="--c:' + e.c + '"><span class="jpm-stg-l">' + e.i + ' ' + e.l + '</span><span class="jpm-stg-n">' + arr.length + '</span><span class="jpm-stg-s">' + sub + '</span><span class="jpm-stg-dot" aria-hidden="true"></span></button>';
    }).join('');
    $('jpm-clr').hidden = !S.etapa;
  }
  function pintarHoy() {
    var por = P.filter(function (p) { return etapa(p) === 'centro'; });
    var cobrar = por.reduce(function (t, p) { return t + p.cobrar; }, 0);
    var cam = P.filter(function (p) { return etapa(p) === 'camino'; });
    var cj = {}; cam.forEach(function (p) { if (p.caja) cj[p.caja] = 1; });
    var cajas = Object.keys(cj);
    var titCam = cajas.length === 1 ? 'Viene la caja ' + cajas[0] : cajas.length > 1 ? 'Vienen ' + cajas.length + ' cajas: ' + cajas.slice(0, 3).join(', ') + (cajas.length > 3 ? '\u2026' : '') : cam.length ? plural(cam.length, 'pedido en camino', 'pedidos en camino') : 'Nada en camino';
    $('jpm-hoy').innerHTML =
      '<button type="button" class="jpm-q' + (S.hoy === 'entregar' ? ' on' : '') + '" data-jpm="hoy" data-k="entregar" style="--c:#4ade80"><span class="jpm-qi" aria-hidden="true">\ud83c\udfc1</span><span><b>' + (por.length ? 'Entregar a ' + plural(por.length, 'cliente', 'clientes') : 'Nadie esperando') + '</b><small>' + (!por.length ? 'cuando llegue una caja, aparecen aqu\u00ed' : cobrar ? 'cobras ' + din(cobrar) + ' en contra entrega' : 'todos pagados: no cobras nada') + '</small></span><span class="jpm-qn">' + por.length + '</span></button>' +
      '<button type="button" class="jpm-q' + (S.hoy === 'recibir' ? ' on' : '') + '" data-jpm="hoy" data-k="recibir" style="--c:#c4b5fd"><span class="jpm-qi" aria-hidden="true">\ud83d\udce5</span><span><b>' + esc(titCam) + '</b><small>' + (cam.length ? plural(cam.length, 'pedido', 'pedidos') + ' \u00b7 al llegar, dispara a la caja y entran todos' : 'te avisamos cuando despachemos') + '</small></span><span class="jpm-qn">' + cam.length + '</span></button>';
  }
  function proxLiquidacion() {
    var h = new Date(), d = h.getDate();
    var f = d < 15 ? new Date(h.getFullYear(), h.getMonth(), 15) : new Date(h.getFullYear(), h.getMonth() + 1, 1);
    try { return f.toLocaleDateString('es-VE', { day: 'numeric', month: 'long' }); } catch (e) { return ''; }
  }
  /* v3.3: la cuenta por etapas — lo que debe YA (entregado) y lo que deberá (en su centro, en camino, en compra) */
  function pintarCuenta() {
    var r = RES || {};
    var D = rdDeuda();
    var comPend = Math.max(0, Math.round(((Number(r.comision_entrega) || 0) - (Number(r.comision_pagada) || 0)) * 100) / 100);
    var enRev = Number(r.rendicion_pendiente) || 0;
    var debeHoy = Math.max(0, Math.round((D.entregado.m - comPend) * 100) / 100);
    var fila = function (ico, t, sub, m, col) { return '<div class="f"><span>' + ico + ' ' + t + '<small>' + sub + '</small></span><b style="color:' + col + '">' + din(m) + '</b></div>'; };
    var cnt = function (x, txt) { return x.n ? plural(x.n, 'pedido', 'pedidos') + ' · ' + txt : 'nada por ahora'; };
    rdCss();
    $('jpm-cuenta').innerHTML =
      '<div class="jpm-neto"><span>' + (debeHoy > 0 ? 'Debes a JBOXLY hoy' : 'Al día con JBOXLY') + '</span><b style="color:' + (debeHoy > 0 ? 'var(--jbad)' : 'var(--jok)') + '">' + din(debeHoy) + '</b></div>' +
      '<div class="jpm-cta">' +
      fila('🏁', 'Entregados y cobrados', cnt(D.entregado, 'debes ya') + (comPend && D.entregado.n ? ' · menos tu comisión ' + din(comPend) : ''), D.entregado.m, 'var(--jbad)') +
      fila('🏬', 'En tu centro, por entregar', cnt(D.centro, 'deberás al entregar'), D.centro.m, '#f9a8d4') +
      fila('✈️', 'En camino a tu centro', cnt(D.camino, 'deberás cuando llegue y entregues'), D.camino.m, '#c4b5fd') +
      fila('🛒', 'En compra / comprados', cnt(D.compra, 'deberás más adelante'), D.compra.m, 'var(--jbl)') +
      (enRev > 0 ? fila('⏳', 'Enviado, en revisión', 'JBOXLY lo descuenta al aprobar', enRev, 'var(--jw)') : '') +
      fila('🎯', 'Tu comisión por cobrar', din(r.comision_entrega) + ' ganada · se descuenta de lo que envías', comPend, 'var(--jok)') +
      '</div>' +
      ((D.entregado.m > 0 || D.centro.m > 0 || D.camino.m > 0 || D.compra.m > 0) ? '<button type="button" class="jpm-btn jpm-pri jpm-rd-btn" data-jpm="rendir">💸 Ya te pagué</button><div class="jpm-rd-nota" style="text-align:center">Entregados o por entregar · total o abono · con foto del comprobante</div>' : '') +
      pintarRendHist() +
      '<div class="jpm-pie">Liquidación quincenal (1 y 15) · próxima: ' + proxLiquidacion() + '</div>';
  }
  function filaHtml(p) {
    var e = etapa(p), et = etq(e);
    var ps = paso(p), mini = '';
    for (var i = 0; i < 5; i++) mini += '<i class="' + (i <= ps ? 'on' : '') + '"></i>';
    var amt = '<span class="jpm-amt">' + din(p.tot) + '</span>' +
      (e === 'cancelada' ? '' : p.met === 'cod' ? (e === 'cliente' ? '<span class="jpm-pag">cobrado</span>' : '<span class="jpm-cod">\ud83d\udcb5 cobras al entregar</span>') : '<span class="jpm-pag">\u2705 pagado</span>') +
      (e !== 'cancelada' && p.com ? '<span class="jpm-com">+' + din(p.com) + ' tuyos</span>' : '');
    var d = dias(p.fecha);
    var viejo = e === 'centro' && dias(p.enCentro) >= 3;
    return '<div class="jpm-row' + (S.abierto === p.id ? ' abierto' : '') + (e === 'cancelada' ? ' canc' : '') + '" data-jpm="ver" data-k="' + esc(p.id) + '" role="button" tabindex="0">' +
      '<div class="jpm-c-code"><span class="jpm-code">' + esc(p.id) + '</span><div class="jpm-orig">' + (p.o === 'propio' ? '\ud83d\uded2 Cargado por ti' : '<span class="as">\ud83d\udce5 Asignado por JBOXLY</span>') + '</div></div>' +
      '<div class="jpm-c-cli"><div class="jpm-nom">' + esc(p.cli) + '</div><div class="jpm-tel">' + esc(p.tel) + '</div></div>' +
      '<div class="jpm-c-st"><span class="jpm-pill" style="--c:' + et.c + '">' + et.i + ' ' + estadoTxt(p) + '</span></div>' +
      '<div class="jpm-c-prog"><div class="jpm-mini">' + mini + '</div><div class="jpm-mini-t">' + esc(notaDe(p)) + '</div></div>' +
      '<div class="jpm-c-amt">' + amt + '</div>' +
      '<div class="jpm-c-age"><span class="jpm-age' + (viejo ? ' old' : '') + '">' + (d < 0 ? '' : d ? d + 'd' : 'hoy') + '</span></div></div>';
  }
  function pintarLista() {
    var v = visibles();
    var fx = [];
    if (S.etapa) fx.push([etq(S.etapa).l, 'etapa']);
    if (S.hoy) fx.push([S.hoy === 'entregar' ? '\ud83c\udfc1 Por entregar' : '\ud83d\udce5 En camino', 'hoy']);
    if (S.q) fx.push(['\u201c' + S.q + '\u201d', 'q']);
    $('jpm-info').innerHTML = '<span>Mostrando ' + v.length + ' de ' + P.length + '</span>' + fx.map(function (f) { return '<span class="jpm-fx">' + esc(f[0]) + '<button type="button" data-jpm="quitar" data-k="' + f[1] + '" aria-label="Quitar filtro">\u00d7</button></span>'; }).join('');
    var vacio = !P.length ? 'Todav\u00eda no tienes pedidos. Usa <b>\uff0b Nuevo pedido</b> para cargar el primero.' : 'Nada con estos filtros.';
    $('jpm-lista').innerHTML = '<div class="jpm-list"><div class="jpm-row hd"><div class="jpm-c-code">Pedido</div><div class="jpm-c-cli">Cliente</div><div class="jpm-c-st">Estado</div><div class="jpm-c-prog">Camino</div><div class="jpm-c-amt">Total</div><div class="jpm-c-age">Edad</div></div>' +
      (v.length ? v.map(filaHtml).join('') : '<div class="jpm-vacio">' + vacio + '</div>') + '</div>';
    ROOT.querySelectorAll('[data-jpm="orig"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-k') === S.orig)); });
    ROOT.querySelectorAll('[data-jpm="pago"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-k') === S.pago)); });
  }
  function pintar() {
    pintarPipe(); pintarHoy(); pintarCuenta(); pintarLista();
    if (S.abierto && !S.editando) pintarDrawer();
  }

  /* --------- ficha del pedido --------- */
  function filaItem(t, pr, c) {
    return '<div class="jpm-itrow"><input placeholder="Producto o link" value="' + esc(t || '') + '" aria-label="Producto"><input placeholder="Precio $" inputmode="decimal" value="' + esc(pr || '') + '" aria-label="Precio"><input placeholder="Cant." inputmode="numeric" value="' + esc(c || 1) + '" aria-label="Cantidad"><button type="button" data-jpm="del-it" aria-label="Quitar producto">\u2715</button></div>';
  }
  function fld(id, lbl, val, tipo) {
    return '<div class="jpm-fld"><label for="' + id + '">' + lbl + '</label><input id="' + id + '"' + (tipo === 'email' ? ' type="email"' : tipo === 'tel' ? ' inputmode="tel"' : '') + ' value="' + esc(val || '') + '" autocomplete="off"></div>';
  }
  function pintarDrawer() {
    var p = byId(S.abierto);
    if (!p) { cerrarDr(); return; }
    var e = etapa(p), et = etq(e), ps = paso(p);
    var nombres = ['Cargado', 'Comprado', 'En camino', 'En tu centro', 'Al cliente'], icos = ['\ud83d\udce5', '\ud83d\uded2', '\u2708\ufe0f', '\ud83c\udfec', '\ud83c\udfc1'];
    var tl = e === 'cancelada' ? '<div class="jpm-nota" style="text-align:center">\ud83d\udeab Este pedido fue cancelado. No lo entregues; si lleg\u00f3 a tu centro, av\u00edsale a JBOXLY.</div>' :
      '<div class="jpm-tl">' + nombres.map(function (n, i) { return '<div class="' + (i < ps ? 'on' : i === ps ? 'on now' : '') + '" data-i="' + icos[i] + '">' + n + '</div>'; }).join('') + '</div>';
    var acc = '';
    if (e === 'centro') {
      acc = S.conf === p.id
        ? '<div class="jpm-blk" style="border-color:var(--jo)"><b style="font-size:15px">\u00bfEntregaste a ' + esc(p.cli) + (p.cobrar ? ' y cobraste ' + din(p.cobrar) : '') + '?</b><div class="jpm-nota" style="margin:4px 0 10px">Al confirmar, ganas ' + din(p.com) + '.' + (p.cobrar ? ' Los ' + din(p.cobrar) + ' quedan como COD por rendir.' : '') + ' Le llega un correo de entrega.</div><button type="button" class="jpm-gran" data-jpm="entregar-ok" data-k="' + esc(p.id) + '"' + (S.enviando ? ' disabled' : '') + '>' + (S.enviando ? 'Registrando\u2026' : '\u2705 S\u00ed, entregu\u00e9' + (p.cobrar ? ' y cobr\u00e9' : '')) + '</button><button type="button" class="jpm-btn" style="width:100%;margin-top:8px" data-jpm="entregar-no">Todav\u00eda no</button></div>'
        : '<button type="button" class="jpm-gran cf" data-jpm="entregar" data-k="' + esc(p.id) + '">\ud83c\udfc1 Entregu\u00e9 a ' + esc(primer(p.cli)) + (p.cobrar ? ' \u00b7 cobr\u00e9 ' + din(p.cobrar) : '') + '</button>';
    }
    var fin = e === 'cliente' ? '<div class="jpm-blk"><b style="color:var(--jok)">\ud83c\udfc1 Entregado al cliente el ' + esc(fcorta(p.ent.fecha)) + '</b><div class="jpm-nota">Tu comisi\u00f3n: ' + din(p.com) + ' \u00b7 se liquida el 1 o el 15</div></div>' : '';
    var wa = soloDig(p.tel);
    var cliB = '<div class="jpm-blk"><h3>\ud83d\udc64 Entregar a</h3><b style="font-size:16px">' + esc(p.cli) + '</b>' +
      (p.tel ? '<div style="margin-top:4px">' + (wa.length >= 8 ? '<a class="jpm-wa" href="https://wa.me/' + wa + '" target="_blank" rel="noopener">\ud83d\udcf1 ' + esc(p.tel) + ' \u00b7 escribir por WhatsApp</a>' : '\ud83d\udcf1 ' + esc(p.tel)) + '</div>' : '') +
      '<div class="jpm-nota" style="margin-top:4px">\ud83d\udccd ' + esc(p.dir || 'Sin direcci\u00f3n') + (p.em ? '<br>\u2709\ufe0f ' + esc(p.em) : '') + (p.nota ? '<br>\ud83d\udcdd ' + esc(p.nota) : '') + '</div>' +
      (p.cobrar && e !== 'cliente' && e !== 'cancelada' ? '<div style="margin-top:8px;color:var(--jw);font-weight:800">\ud83d\udcb5 Cobrar al entregar: ' + din(p.cobrar) + (p.abonado ? ' <span class="jpm-nota">(ya abon\u00f3 ' + din(p.abonado) + ')</span>' : '') + '</div>' : '') + '</div>';
    var prods = '<div class="jpm-blk"><h3>\ud83d\uded2 Productos</h3>' + (p.items.length ? p.items.map(function (x) {
      var tit = esc(x.titulo || 'Producto');
      if (x.url && /^https?:\/\//i.test(x.url)) tit = '<a href="' + esc(x.url) + '" target="_blank" rel="noopener">' + tit + ' <span style="color:var(--jo);font-size:11px">ver \u2197</span></a>';
      var meta = [x.tienda, x.variante].filter(Boolean).map(esc).join(' \u00b7 ');
      return '<div class="jpm-it">' + (x.imagen && /^https?:\/\//i.test(x.imagen) ? '<img src="' + esc(x.imagen) + '" alt="" loading="lazy">' : '') + '<span class="t">' + tit + (meta ? '<small>' + meta + '</small>' : '') + '</span><span class="p">' + esc(x.precio) + ' \u00d7 ' + (x.cantidad || 1) + '</span></div>';
    }).join('') : '<div class="jpm-nota">Sin detalle de productos.</div>') + '</div>';
    var g = p.desg, res;
    if (g && g.total) {
      var kv = function (l, v) { return v ? '<div class="jpm-kv"><span>' + l + '</span><b>' + din(v) + '</b></div>' : ''; };
      res = '<div class="jpm-blk"><h3>\ud83e\uddfe Resumen (fijado por JBOXLY)</h3>' + kv('Productos', g.productos) + kv('Env\u00edo', g.envio) + kv('Manejo y log\u00edstica', g.fee) + kv('Seguro', g.seguro) + kv('Impuestos', g.impuestos) + kv('Caja', g.caja) + '<div class="jpm-kv tot"><span>Total</span><b>' + din(g.total) + '</b></div></div>';
    } else {
      res = '<div class="jpm-blk"><h3>\ud83e\uddfe Resumen</h3><div class="jpm-kv tot" style="border:0;margin:0;padding:0"><span>Total</span><b>' + din(p.tot) + '</b></div></div>';
    }
    var editable = p.o === 'propio' && (p.st === 'recibida' || p.st === 'comprado');
    var pieEd = S.editando === p.id ? htmlEditar(p) :
      editable ? '<button type="button" class="jpm-btn" data-jpm="editar" data-k="' + esc(p.id) + '">\u270f\ufe0f Editar ' + (prodsEditables(p) ? 'productos o datos del cliente' : 'datos del cliente') + '</button>' :
      e === 'compra' ? '<div class="jpm-nota">Este pedido lo carg\u00f3 JBOXLY: para cambios, escr\u00edbele a JBOXLY.</div>' :
      e === 'camino' ? '<div class="jpm-nota">Pedido en tr\u00e1nsito: para cambios, escr\u00edbele a JBOXLY.</div>' : '';
    $('jpm-drawer').innerHTML =
      '<div class="jpm-dr-h"><button type="button" class="jpm-x" data-jpm="cerrar-dr" aria-label="Cerrar">\u2190</button><div style="flex:1;min-width:0"><h2><span class="jpm-mono">' + esc(p.id) + '</span></h2><p>' + (p.o === 'propio' ? '\ud83d\uded2 Cargado por ti' : '\ud83d\udce5 Asignado por JBOXLY') + ' \u00b7 <span class="jpm-pill" style="--c:' + et.c + '">' + et.i + ' ' + estadoTxt(p) + '</span>' + (p.caja ? ' \u00b7 \ud83e\uddf0 ' + esc(p.caja) : '') + '</p></div></div>' +
      '<div class="jpm-dr-b"><div class="jpm-blk">' + tl + '</div>' + acc + fin + cliB + prods + res + pieEd + '</div>';
  }
  /* los productos solo se cambian en pedidos de Carga r\u00e1pida y antes de que JBOXLY compre */
  function prodsEditables(p) { return p.st === 'recibida' && p.origen === 'master'; }
  function htmlEditar(p) {
    var its = p.items.length ? p.items : [{ titulo: '', precio: '', cantidad: 1 }];
    var bloqueProds = prodsEditables(p)
      ? '<div><div class="jpm-flbl" style="margin-bottom:6px">Productos</div><div class="jpm-items" id="jpm-e-items">' + its.map(function (x) { return filaItem(x.titulo, num(x.precio) || '', x.cantidad || 1); }).join('') + '</div>' +
        '<button type="button" class="jpm-btn jpm-sm" data-jpm="add-it" data-k="jpm-e-items" style="margin-top:8px">+ Otro producto</button></div>' +
        '<div class="jpm-totv">Total del pedido: <b id="jpm-e-tot">' + din(totDe('x', its)) + '</b></div>'
      : '<div class="jpm-nota">Los productos ya no se cambian desde aqu\u00ed (' + (p.st === 'recibida' ? 'el pedido viene del buscador, con env\u00edo calculado' : 'JBOXLY ya los compr\u00f3') + '). Si hace falta, escr\u00edbele a JBOXLY.</div>';
    return '<form class="jpm-blk jpm-edit" id="jpm-f-edit" novalidate><h3>\u270f\ufe0f Editar pedido</h3>' + bloqueProds +
      '<div class="jpm-two">' + fld('jpm-e-nom', 'Nombre *', p.cli) + fld('jpm-e-tel', 'Tel\u00e9fono *', p.tel, 'tel') + '</div>' +
      '<div class="jpm-two">' + fld('jpm-e-em', 'Email *', p.em, 'email') + fld('jpm-e-dir', 'Direcci\u00f3n o zona *', p.dir) + '</div>' +
      fld('jpm-e-nota', 'Nota (opcional)', p.nota) +
      '<div class="jpm-err" id="jpm-e-err" role="alert" hidden></div>' +
      '<div class="jpm-dlg-f"><button type="button" class="jpm-btn" data-jpm="edit-no">Cancelar</button><button type="submit" class="jpm-btn jpm-pri" id="jpm-e-btn">Guardar cambios</button></div></form>';
  }
  function abrirDr(id) {
    S.abierto = id; S.conf = null; S.editando = null;
    $('jpm-fondo').hidden = false; $('jpm-drawer').hidden = false; lock(true);
    pintarDrawer(); pintarLista();
    $('jpm-drawer').scrollTop = 0;
    var x = $('jpm-drawer').querySelector('.jpm-x'); if (x) x.focus();
  }
  function cerrarDr() {
    var id = S.abierto;
    S.abierto = null; S.conf = null; S.editando = null;
    $('jpm-fondo').hidden = true; $('jpm-drawer').hidden = true;
    if (!capasAbiertas()) lock(false);
    pintarLista();
    if (id) { var r = ROOT.querySelector('.jpm-row[data-k="' + id + '"]'); if (r) r.focus(); }
  }

  /* --------- entregar al cliente --------- */
  function entregar(id, desdeEst) {
    var p = byId(id);
    if (!p || S.enviando) return Promise.resolve(false);
    S.enviando = true;
    if (S.abierto === id) pintarDrawer();
    return api('master-entregar-cliente', { idPedido: id }).then(function (d) {
      S.enviando = false;
      if (d.ok) {
        p.ent = p.ent || { fecha: new Date().toISOString() };
        recordar(p.id, { ent: p.ent });
        S.conf = null;
        if (!desdeEst) toast('\ud83c\udfc1 ' + p.cli + (d.ya ? ' ya estaba entregado' : ' entregado \u00b7 ganaste ' + din(p.com)));
        pintar();
        cargar(true);
        return d.ya ? 'ya' : true;
      }
      if (!desdeEst) toast('\u274c ' + (d.error || 'No se pudo marcar la entrega'));
      if (S.abierto === id) pintarDrawer();
      return d.error || 'No se pudo marcar la entrega';
    }).catch(function () {
      S.enviando = false;
      if (!desdeEst) toast('\u274c Sin conexi\u00f3n: intenta de nuevo');
      if (S.abierto === id) pintarDrawer();
      return 'Sin conexi\u00f3n: intenta de nuevo';
    });
  }

  /* --------- formularios: productos --------- */
  function leerItems(contId) {
    var items = [], err = '';
    document.querySelectorAll('#' + contId + ' .jpm-itrow').forEach(function (r) {
      var i = r.querySelectorAll('input');
      var t = i[0].value.trim(), pr = num(i[1].value), c = Math.max(1, parseInt(i[2].value, 10) || 1);
      if (!t && !i[1].value.trim()) return;
      if (!t) err = err || 'A un producto le falta el nombre o link.';
      else if (!pr) err = err || 'Cada producto necesita su precio.';
      else items.push({ titulo: t, precio: pr, cantidad: c });
    });
    if (!err && !items.length) err = 'Agrega al menos un producto con su precio.';
    return { items: items, err: err };
  }
  function totDe(contId, arr) {
    var t = 0;
    if (arr) { arr.forEach(function (x) { t += num(x.precio) * (parseInt(x.cantidad, 10) || 1); }); return t; }
    document.querySelectorAll('#' + contId + ' .jpm-itrow').forEach(function (r) { var i = r.querySelectorAll('input'); t += num(i[1].value) * (parseInt(i[2].value, 10) || 1); });
    return t;
  }
  function errCliente(nom, tel, em, dir) {
    if (!nom || !tel || !em || !dir) return 'Completa nombre, tel\u00e9fono, email y direcci\u00f3n del cliente.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) return 'Revisa el email del cliente.';
    if (soloDig(tel).length < 7) return 'Revisa el tel\u00e9fono del cliente.';
    return '';
  }
  function mostrarErr(id, t) { var el = $(id); if (!el) return; el.textContent = t || ''; el.hidden = !t; }

  /* --------- carga r\u00e1pida --------- */
  function clientes() {
    var vis = {}, l = [];
    P.slice().sort(function (a, b) { return tiempo(b) - tiempo(a); }).forEach(function (p) {
      var k = soloDig(p.tel) || norm(p.em);
      if (!k || vis[k] || !p.cli || p.cli === 'Sin nombre') return;
      vis[k] = 1; l.push(p);
    });
    return l;
  }
  var CLI_RES = [];
  function abrirRapida() {
    ['jpm-r-cli', 'jpm-r-nom', 'jpm-r-tel', 'jpm-r-em', 'jpm-r-dir', 'jpm-r-nota'].forEach(function (i) { $(i).value = ''; });
    $('jpm-r-res').innerHTML = '';
    $('jpm-r-items').innerHTML = filaItem();
    $('jpm-r-tot').textContent = din(0);
    var m = document.querySelector('input[name="jpm-met"][value="contra_entrega"]'); if (m) m.checked = true;
    mostrarErr('jpm-r-err', '');
    $('jpm-r-btn').disabled = false; $('jpm-r-btn').textContent = 'Crear pedido';
    $('jpm-dlg').hidden = false; lock(true);
    setTimeout(function () { $('jpm-r-cli').focus(); }, 50);
  }
  function cerrarRapida() { $('jpm-dlg').hidden = true; if (!capasAbiertas()) lock(false); }
  function buscarCliente() {
    var q = norm($('jpm-r-cli').value.trim()), qd = soloDig(q);
    if (q.length < 2) { $('jpm-r-res').innerHTML = ''; return; }
    CLI_RES = clientes().filter(function (p) {
      return norm(p.cli + ' ' + p.em).indexOf(q) !== -1 || (qd.length >= 3 && soloDig(p.tel).indexOf(qd) !== -1);
    }).slice(0, 5);
    $('jpm-r-res').innerHTML = CLI_RES.length ? CLI_RES.map(function (p, i) { return '<button type="button" data-jpm="pick" data-k="' + i + '"><span>' + esc(p.cli) + '</span><small>' + esc(p.tel) + ' \u00b7 ya te compr\u00f3</small></button>'; }).join('') : '<div class="jpm-nota">Cliente nuevo: llena sus datos abajo.</div>';
  }
  function crearPedido(e) {
    e.preventDefault();
    if (S.enviando) return;
    var nom = $('jpm-r-nom').value.trim(), tel = $('jpm-r-tel').value.trim(), em = $('jpm-r-em').value.trim().toLowerCase(), dir = $('jpm-r-dir').value.trim();
    var it = leerItems('jpm-r-items');
    var err = errCliente(nom, tel, em, dir) || it.err;
    mostrarErr('jpm-r-err', err);
    if (err) return;
    var met = (document.querySelector('input[name="jpm-met"]:checked') || {}).value === 'pagado' ? 'pagado' : 'contra_entrega';
    S.enviando = true;
    var b = $('jpm-r-btn'); b.disabled = true; b.textContent = 'Creando\u2026';
    api('master-crear-pedido', {
      productos: it.items, metodo: met, nota: $('jpm-r-nota').value.trim(),
      cliente_final: { nombre: nom, telefono: tel, email: em, direccion: dir }
    }).then(function (d) {
      S.enviando = false; b.disabled = false; b.textContent = 'Crear pedido';
      if (!d.ok) { mostrarErr('jpm-r-err', d.error || 'No se pudo crear el pedido.'); return; }
      cerrarRapida();
      S.etapa = ''; S.hoy = '';
      toast('\u2705 Pedido ' + (d.idPedido || '') + ' creado para ' + nom);
      cargar(true);
    }).catch(function () {
      S.enviando = false; b.disabled = false; b.textContent = 'Crear pedido';
      mostrarErr('jpm-r-err', 'Sin conexi\u00f3n: el pedido NO se cre\u00f3. Intenta de nuevo.');
    });
  }

  /* --------- editar pedido (desde la ficha) --------- */
  function guardarEdicion(e) {
    e.preventDefault();
    var p = byId(S.editando);
    if (!p || S.enviando) return;
    var nom = $('jpm-e-nom').value.trim(), tel = $('jpm-e-tel').value.trim(), em = $('jpm-e-em').value.trim().toLowerCase(), dir = $('jpm-e-dir').value.trim();
    var conProds = !!$('jpm-e-items');
    var it = conProds ? leerItems('jpm-e-items') : { items: null, err: '' };
    var err = errCliente(nom, tel, em, dir) || it.err;
    mostrarErr('jpm-e-err', err);
    if (err) return;
    S.enviando = true;
    var b = $('jpm-e-btn'); b.disabled = true; b.textContent = 'Guardando\u2026';
    var datosEd = { idPedido: p.id, nota: $('jpm-e-nota').value.trim(), cliente_final: { nombre: nom, telefono: tel, email: em, direccion: dir } };
    if (conProds) datosEd.productos = it.items;
    api('master-editar-pedido', datosEd).then(function (d) {
      S.enviando = false;
      if (!d.ok) { b.disabled = false; b.textContent = 'Guardar cambios'; mostrarErr('jpm-e-err', d.error || 'No se pudo guardar.'); return; }
      S.editando = null;
      toast('\u2705 Pedido ' + p.id + ' actualizado');
      cargar(true);
    }).catch(function () {
      S.enviando = false; b.disabled = false; b.textContent = 'Guardar cambios';
      mostrarErr('jpm-e-err', 'Sin conexi\u00f3n: no se guard\u00f3. Intenta de nuevo.');
    });
  }

  /* ========= ESTACI\u00d3N DE ESCANEO ========= */
  var MODOS = {
    recibir: ['\ud83d\udce5 Recib\u00ed en mi centro', 'Dispara a la etiqueta de la caja y entran todos sus pedidos. Tambi\u00e9n sirve la etiqueta de cada pedido o bulto.'],
    entregar: ['\ud83c\udfc1 Entregu\u00e9 al cliente', 'Dispara a la etiqueta del pedido: te digo a qui\u00e9n es y cu\u00e1nto cobrar. Dispara otra vez para confirmar.'],
    consulta: ['\ud83d\udd0d Consultar', 'Dispara a cualquier etiqueta para ver de qui\u00e9n es y en qu\u00e9 va. No registra nada.']
  };
  function card(t, titulo, html) {
    var c = $('jpm-card');
    c.setAttribute('data-t', t);
    c.classList.remove('jpm-flash'); void c.offsetWidth;
    if (t !== 'idle') c.classList.add('jpm-flash');
    $('jpm-card-t').textContent = titulo;
    $('jpm-card-b').innerHTML = html;
  }
  function logEst(txt) {
    var li = document.createElement('li');
    var s = document.createElement('span'); s.textContent = txt;
    var t = document.createElement('time'); t.textContent = hora();
    li.appendChild(s); li.appendChild(t);
    var l = $('jpm-log'); l.insertBefore(li, l.firstChild);
    while (l.children.length > 40) l.removeChild(l.lastChild);
  }
  function contar() { S.n++; $('jpm-est-n').textContent = S.n; }
  function beep(ok) {
    try {
      if (!window.__jpmAudio) window.__jpmAudio = new (window.AudioContext || window.webkitAudioContext)();
      var x = window.__jpmAudio, t = x.currentTime;
      if (x.state === 'suspended') x.resume();
      (ok ? [[1320, 0, 0.07], [1760, 0.08, 0.09]] : [[160, 0, 0.4]]).forEach(function (n) {
        var o = x.createOscillator(), g = x.createGain();
        o.type = ok ? 'sine' : 'square'; o.frequency.value = n[0];
        g.gain.setValueAtTime(0.0001, t + n[1]);
        g.gain.exponentialRampToValueAtTime(ok ? 0.25 : 0.14, t + n[1] + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + n[1] + n[2]);
        o.connect(g); g.connect(x.destination); o.start(t + n[1]); o.stop(t + n[1] + n[2] + 0.03);
      });
    } catch (e) {}
    try { if (navigator.vibrate) navigator.vibrate(ok ? 60 : [90, 60, 90]); } catch (e) {}
  }
  function ocupado(on) { S.ocupado = on; indicador(on); }
  function indicador(on) {
    if (CAM.on && !on) { $('jpm-estado').classList.remove('ocupado'); $('jpm-estado').querySelector('span').textContent = 'C\u00e1mara lista \u00b7 apunta al c\u00f3digo'; return; }
    var el = $('jpm-estado');
    el.classList.toggle('ocupado', on);
    el.querySelector('span').textContent = on ? 'Registrando\u2026 sigue disparando' : 'L\u00e1ser listo \u00b7 dispara a una etiqueta';
  }
  function modo(k) {
    S.modo = k; S.pend = null;
    document.querySelectorAll('#jpm-est [data-jpm="modo"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-k') === k)); });
    card('idle', MODOS[k][0], esc(MODOS[k][1]));
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
  }
  function abrirEst(m) {
    if (!SES) return;
    $('jpm-est').hidden = false; S.estAb = true; lock(true);
    $('jpm-menu').hidden = true;
    modo(m || S.modo);
  }
  function cerrarEst() {
    camApagar();
    $('jpm-est').hidden = true; S.estAb = false; S.pend = null; S.buf = '';
    if (!capasAbiertas()) lock(false);
    pintar();
  }
  function limpiar(raw) {
    /* algunos l\u00e1ser con teclado en espa\u00f1ol mandan ' o ? en vez del guion */
    return String(raw || '').trim().toUpperCase().replace(/[\s]+/g, '').replace(/['\u00b4?\u00bf_]/g, '-');
  }
  var RX_PED = /^((?:PED|PAQ)-\d{6}-\d{4})(?:-(\d{1,2}))?$/;
  function nomPed(p) { return '<span class="grande">' + esc(String(p.cli || '').toUpperCase()) + '</span>'; }

  function leer(raw, via) {
    var c = limpiar(raw);
    if (!c) return;
    if (via === 'cam') {
      if (!S.estAb) return;
      var ah = Date.now();
      /* la etiqueta frente a la c\u00e1mara se lee sola muchas veces: se registra
         una vez y no se repite hasta que deje de verse 2.5 s */
      if (c === S.camUlt && ah - S.camTs < 2500) { S.camTs = ah; return; }
      S.camUlt = c; S.camTs = ah;
    }
    $('jpm-eco').textContent = '\u00daltimo c\u00f3digo: ' + c;
    if (S.modo === 'recibir') { S.cola.push(c); siguiente(); return; }
    var m = RX_PED.exec(c);
    if (S.modo === 'consulta') { consultar(c, m); return; }
    entregarScan(c, m, via);
  }

  function consultar(c, m) {
    if (!m) {
      var caja = P.filter(function (p) { return p.caja === c; });
      if (caja.length) {
        card('info', '\ud83e\uddf0 Caja ' + c, plural(caja.length, 'pedido', 'pedidos') + ' de tu centro:<ul>' + caja.map(function (x) { return '<li>' + esc(x.id) + ' \u00b7 ' + esc(x.cli) + ' \u00b7 ' + estadoTxt(x) + '</li>'; }).join('') + '</ul>');
        beep(true); logEst('\ud83d\udd0d ' + c); return;
      }
      card('err', '\u2753 No es de tu centro', esc(c) + ' no est\u00e1 en tus pedidos ni en tus cajas.'); beep(false); return;
    }
    var p = byId(m[1]);
    if (!p) { card('err', '\u2753 No es de tu centro', esc(m[1]) + ' no est\u00e1 en tus pedidos.'); beep(false); return; }
    var e = etapa(p);
    card('info', '\ud83d\udd0d ' + p.id, nomPed(p) + etq(e).i + ' ' + estadoTxt(p) + ' \u00b7 ' + esc(notaDe(p)) + '<br>' +
      (p.cobrar && e !== 'cliente' && e !== 'cancelada' ? '\ud83d\udcb5 Cobrar ' + din(p.cobrar) : '\u2705 Pagado') + (p.tel ? ' \u00b7 \ud83d\udcf1 ' + esc(p.tel) : ''));
    beep(true); logEst('\ud83d\udd0d ' + p.id + ' \u00b7 ' + p.cli);
  }

  function entregarScan(c, m, via) {
    if (!m) {
      card('err', '\ud83e\uddf0 Eso no es un pedido', 'Para entregar, dispara a la etiqueta del pedido (PED-\u2026), no a la de la caja.'); beep(false); return;
    }
    var p = byId(m[1]);
    if (!p) {
      if (!S.reintento) { S.reintento = true; card('info', '\u23f3 Buscando\u2026', esc(m[1])); cargar(true).then(function () { entregarScan(c, m, via); S.reintento = false; }); return; }
      S.reintento = false;
      card('err', '\u2753 No es de tu centro', esc(m[1]) + ' no est\u00e1 en tus pedidos.'); beep(false); return;
    }
    var e = etapa(p);
    if (e === 'cliente') { S.pend = null; card('warn', '\ud83d\udd01 Ya estaba entregado', esc(p.id) + ' \u00b7 ' + esc(p.cli) + ' \u00b7 el ' + esc(fcorta(p.ent.fecha))); beep(true); return; }
    if (e === 'cancelada') { S.pend = null; card('err', '\ud83d\udeab Pedido cancelado', esc(p.id) + ' \u00b7 ' + esc(p.cli) + '. No lo entregues; av\u00edsale a JBOXLY.'); beep(false); return; }
    if (e !== 'centro') {
      S.pend = null;
      card('err', '\ud83d\udeab Todav\u00eda no llega a tu centro', esc(p.id) + ' \u00b7 ' + esc(p.cli) + ' est\u00e1 "' + estadoTxt(p) + '".<br><span class="dim">Si lo tienes en la mano, primero disp\u00e1ralo en \ud83d\udce5 Recib\u00ed.</span>'); beep(false); return;
    }
    if (S.pend === p.id && via !== 'cam') {
      var dt = Date.now() - S.pendTs;
      if (dt < 500) return;                              /* doble lectura del l\u00e1ser: se ignora */
      if (dt <= 60000) { confirmarEst(p.id); return; }   /* pasado 1 minuto, vuelve a preguntar */
    }
    S.pend = p.id; S.pendTs = Date.now();
    card('warn', '\ud83c\udfc1 \u00bfEntregas a ' + primer(p.cli) + '?', nomPed(p) + esc(p.id) +
      (p.cobrar ? '<br><b style="color:var(--jw);font-size:1.3em">\ud83d\udcb5 Cobra ' + din(p.cobrar) + '</b>' : '<br>\u2705 Ya est\u00e1 pagado: no cobres nada') +
      '<br><span class="dim">' + (via === 'cam' ? 'Toca el bot\u00f3n para confirmar.' : 'Dispara otra vez la misma etiqueta para confirmar, o toca el bot\u00f3n.') + '</span>' +
      '<button type="button" class="jpm-gran" data-jpm="est-ok" data-k="' + esc(p.id) + '">\u2705 S\u00ed, entregu\u00e9' + (p.cobrar ? ' y cobr\u00e9' : '') + '</button>');
    beep(true);
  }
  function confirmarEst(id) {
    var p = byId(id);
    if (!p || S.enviando) return;
    S.pend = null;
    card('info', '\u23f3 Registrando entrega\u2026', nomPed(p));
    indicador(true);
    entregar(id, true).then(function (r) {
      indicador(S.ocupado);
      if (r === true) {
        contar(); logEst('\ud83c\udfc1 ' + p.id + ' \u00b7 ' + p.cli);
        card('ok', '\ud83c\udfc1 \u00a1Entregado!', nomPed(p) + (p.cobrar ? '\ud83d\udcb5 ' + din(p.cobrar) + ' quedan como COD por rendir<br>' : '') + '\ud83c\udfaf Ganaste ' + din(p.com));
        beep(true);
      } else if (r === 'ya') {
        card('warn', '\ud83d\udd01 Ya estaba entregado', esc(p.id) + ' \u00b7 ' + esc(p.cli)); beep(true);
      } else {
        card('err', '\u274c No se pudo registrar', esc(r || 'Intenta de nuevo.')); beep(false);
      }
    });
  }

  /* Recibir: va al servidor; cola para que el l\u00e1ser nunca se pierda un disparo */
  function siguiente() {
    if (S.ocupado || !S.cola.length) return;
    var c = S.cola.shift();
    ocupado(true);
    if (!S.cola.length) card('info', '\u23f3 Registrando\u2026', '<span class="grande">' + esc(c) + '</span>');
    api('master-scan-recibir', { codigoScan: c }).then(function (d) {
      ocupado(false);
      pintarRecibir(c, d);
      siguiente();
    }).catch(function () {
      ocupado(false);
      card('err', '\u274c Sin conexi\u00f3n', esc(c) + ' NO se registr\u00f3. Dispara otra vez cuando vuelva la se\u00f1al.'); beep(false); logEst('\u274c ' + c + ' \u00b7 sin conexi\u00f3n');
      siguiente();
    });
  }
  function lineaRes(x) {
    var extra = x.omitido === 'bulto-invalido' ? ' \u00b7 \ud83d\udeab bulto inv\u00e1lido' : x.omitido === 'cancelado' ? ' \u00b7 \ud83d\udeab cancelado' : x.omitido === 'sin-salir' ? ' \u00b7 no ha salido de USA' : x.entregado ? ' \u00b7 ya entregado' : x.ya ? ' \u00b7 ya estaba' : x.error ? ' \u00b7 \u274c no se guard\u00f3' : x.completo === false ? ' \u00b7 \u23f3 ' + x.bultos + '/' + x.total_bultos + ' bultos' : '';
    var cod = /contra[\s_-]?entrega/i.test(x.metodo || '') && !x.entregado && !x.omitido ? ' \u00b7 \ud83d\udcb5 ' + din(x.total) : '';
    return '<li>' + esc(x.idPedido) + ' \u00b7 ' + esc(x.cliente || '') + cod + extra + '</li>';
  }
  function pintarRecibir(c, d) {
    if (!d || !d.ok) {
      if (d && d._st === 401) return;
      var msg = (d && d.error) || 'No se pudo registrar';
      card('err', d && d._st === 404 ? '\u2753 ' + msg : '\u274c ' + msg, '<span class="grande">' + esc(c) + '</span>' + (d && d._st === 404 ? '<span class="dim">Revisa la etiqueta. Si lleg\u00f3 a tu centro por error, av\u00edsale a JBOXLY.</span>' : ''));
      beep(false); logEst('\u2753 ' + c); return;
    }
    var rs = d.resultados || [];
    rs.forEach(function (x) {
      var lp = byId(x.idPedido); if (!lp) return;
      var cambios = {};
      if (x.bultos) cambios.bc = x.bultos;
      if (x.nuevo) { cambios.st = 'en-centro'; cambios.enCentro = new Date().toISOString(); }
      if (!Object.keys(cambios).length) return;
      Object.keys(cambios).forEach(function (k) { lp[k] = cambios[k]; });
      recordar(lp.id, cambios);
    });
    var nuevos = rs.filter(function (x) { return x.nuevo; });
    if (d.esCaja) {
      var ok = nuevos.length > 0;
      card(ok ? 'ok' : 'warn', ok ? '\ud83e\uddf0 Caja ' + c + ' recibida' : '\ud83d\udd01 Esa caja ya estaba recibida',
        (ok ? plural(nuevos.length, 'pedido pasa', 'pedidos pasan') + ' a Por entregar:' : 'No hay pedidos nuevos en esta caja:') + '<ul>' + rs.map(lineaRes).join('') + '</ul>');
      beep(true);
      if (ok) { contar(); logEst('\ud83e\uddf0 ' + c + ' \u00b7 ' + plural(nuevos.length, 'pedido recibido', 'pedidos recibidos')); }
      cargar(true); return;
    }
    var x = rs[0] || {};
    var p = byId(x.idPedido) || { cli: x.cliente, id: x.idPedido };
    var cobra = /contra[\s_-]?entrega/i.test(x.metodo || '') ? Math.max(0, (p.cobrar != null ? p.cobrar : x.total)) : 0;
    if (x.omitido === 'bulto-invalido') { card('err', '\ud83d\udeab Ese bulto no es de este pedido', esc(x.idPedido) + ' solo tiene ' + plural(x.total_bultos, 'bulto', 'bultos') + '. Revisa la etiqueta.'); beep(false); return; }
    if (x.omitido === 'sin-salir') { card('err', '\ud83d\udeab Ese pedido todav\u00eda no sale de USA', esc(x.idPedido) + ' \u00b7 ' + esc(x.cliente) + '. Revisa la etiqueta.'); beep(false); return; }
    if (x.omitido === 'cancelado') { card('err', '\ud83d\udeab Pedido cancelado', esc(x.idPedido) + ' \u00b7 ' + esc(x.cliente) + '. No lo entregues; av\u00edsale a JBOXLY.'); beep(false); return; }
    if (x.entregado) { card('warn', '\ud83d\udd01 Ya estaba entregado', esc(x.idPedido) + ' \u00b7 ' + esc(x.cliente)); beep(true); return; }
    if (x.error) { card('err', '\u274c No se pudo registrar', esc(x.idPedido) + '. Dispara otra vez.'); beep(false); return; }
    if (x.completo === false) {
      var falta = x.total_bultos - x.bultos;
      card('warn', '\u23f3 Bulto recibido: ' + x.bultos + ' de ' + x.total_bultos, nomPed(p) + esc(x.idPedido) + '<br>' + (falta === 1 ? 'Falta 1 bulto' : 'Faltan ' + falta + ' bultos') + ' de este pedido. Cuando llegue' + (falta === 1 ? '' : 'n') + ', dispara su etiqueta.');
      beep(true); contar(); logEst('\ud83d\udce5 ' + c + ' \u00b7 bulto ' + x.bultos + '/' + x.total_bultos); cargar(true); return;
    }
    if (x.ya) { card('warn', '\ud83d\udd01 Ya estaba en tu centro', nomPed(p) + esc(x.idPedido)); beep(true); return; }
    card('ok', '\ud83d\udce5 Recibido en tu centro', nomPed(p) + esc(x.idPedido) + (cobra ? '<br>\ud83d\udcb5 Cobra ' + din(cobra) + ' al entregar' : '<br>\u2705 Pagado: no cobras nada'));
    beep(true); contar(); logEst('\ud83d\udce5 ' + x.idPedido + ' \u00b7 ' + (x.cliente || '')); cargar(true);
  }

  /* C\u00e1mara del tel\u00e9fono: lector propio (v3.1).
     Antes se usaba html5-qrcode, que decodifica la imagen ACHICADA al tama\u00f1o de
     la pantalla: un c\u00f3digo de barras largo quedaba con menos de 1 p\u00edxel por
     barra y casi nunca le\u00eda. Ahora se lee a la resoluci\u00f3n real de la c\u00e1mara:
       1) Android/Chrome: lector nativo del tel\u00e9fono (BarcodeDetector), r\u00e1pido.
       2) iPhone y el resto: ZXing sobre la franja central de la imagen.
     Solo se buscan los formatos de nuestras etiquetas (Code128 y QR). */
  var ZX_URL = 'https://cdn.jsdelivr.net/npm/@zxing/library@0.21.3/umd/index.min.js';
  var ZX_SRI = 'sha384-BzBxP10ZE72aitqj5UMmUsbKFliP/DZqA8Wq+BNNhlIJDGoEd1tpkMYXOg9+n6sB';
  var CAM = { on: false, arrancando: false, stream: null, track: null, video: null, det: null, zx: null, cv: null, ctx: null, tm: null, luz: false, cargandoZX: null };

  function camZX() {
    if (CAM.zx) return Promise.resolve('zxing');
    if (CAM.cargandoZX) return CAM.cargandoZX;
    CAM.cargandoZX = new Promise(function (ok, ko) {
      function listo() {
        try {
          var Z = window.ZXing;
          var h = new Map();
          h.set(Z.DecodeHintType.POSSIBLE_FORMATS, [Z.BarcodeFormat.CODE_128, Z.BarcodeFormat.QR_CODE, Z.BarcodeFormat.CODE_39]);
          h.set(Z.DecodeHintType.TRY_HARDER, true);
          CAM.zx = new Z.MultiFormatReader();
          CAM.zx.setHints(h);
          CAM.cv = document.createElement('canvas');
          CAM.ctx = CAM.cv.getContext('2d', { willReadFrequently: true });
          ok('zxing');
        } catch (e) { ko('lib'); }
      }
      if (window.ZXing && window.ZXing.MultiFormatReader) { listo(); return; }
      var s = document.createElement('script');
      s.src = ZX_URL; s.integrity = ZX_SRI; s.crossOrigin = 'anonymous';
      s.onload = listo;
      s.onerror = function () { CAM.cargandoZX = null; ko('lib'); };
      document.head.appendChild(s);
    });
    return CAM.cargandoZX;
  }
  function camMotor() {
    if (CAM.det) return Promise.resolve('nativo');
    if ('BarcodeDetector' in window && window.BarcodeDetector.getSupportedFormats) {
      return window.BarcodeDetector.getSupportedFormats().then(function (fs) {
        var q = ['code_128', 'qr_code', 'code_39'].filter(function (f) { return fs.indexOf(f) !== -1; });
        if (q.indexOf('code_128') === -1) return camZX();
        CAM.det = new window.BarcodeDetector({ formats: q });
        camZX().catch(function () {}); /* de respaldo, en segundo plano (etiquetas sin margen) */
        return 'nativo';
      }).catch(camZX);
    }
    return camZX();
  }
  function camUI(on) {
    $('jpm-camw').hidden = !on;
    $('jpm-est').classList.toggle('jpm-cam-on', on);
    $('jpm-cam-btn').textContent = on ? '\u2715 C\u00e1mara' : '\ud83d\udcf7 C\u00e1mara';
    $('jpm-estado').querySelector('span').textContent = on ? 'C\u00e1mara lista \u00b7 apunta al c\u00f3digo' : (S.ocupado ? 'Registrando\u2026 sigue disparando' : 'L\u00e1ser listo \u00b7 dispara a una etiqueta');
    if (!on) { $('jpm-torch').hidden = true; $('jpm-torch').setAttribute('aria-pressed', 'false'); CAM.luz = false; }
  }
  function camSoltar() {
    clearTimeout(CAM.tm);
    if (CAM.stream) CAM.stream.getTracks().forEach(function (t) { try { t.stop(); } catch (e) {} });
    CAM.stream = null; CAM.track = null;
    if (CAM.video) { try { CAM.video.srcObject = null; } catch (e) {} if (CAM.video.parentNode) CAM.video.parentNode.removeChild(CAM.video); }
    CAM.video = null;
  }
  function camFallo(msg) {
    camSoltar();
    CAM.arrancando = false; CAM.on = false;
    camUI(false);
    toast(msg || 'No se pudo abrir la c\u00e1mara: usa el l\u00e1ser o escribe el c\u00f3digo');
  }
  function camToggle() {
    if (CAM.on || CAM.arrancando) { camApagar(); return; }
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { toast('Este navegador no deja usar la c\u00e1mara: usa el l\u00e1ser o escribe el c\u00f3digo'); return; }
    CAM.arrancando = true;
    camUI(true);
    $('jpm-cam-btn').textContent = '\u23f3 C\u00e1mara';
    navigator.mediaDevices.getUserMedia({ audio: false, video: {
      facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1080 },
      advanced: [{ focusMode: 'continuous' }]
    } }).then(function (stream) {
      CAM.stream = stream;
      CAM.track = stream.getVideoTracks()[0] || null;
      if (!CAM.arrancando) { camSoltar(); return; }
      return camMotor().then(function () {
        if (!CAM.arrancando) { camSoltar(); return; }
        var v = document.createElement('video');
        v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.muted = true; v.autoplay = true;
        v.srcObject = stream;
        var z = $('jpm-cam'); z.innerHTML = ''; z.appendChild(v);
        CAM.video = v;
        var pl = v.play();
        return (pl && pl.catch ? pl.catch(function () {}) : Promise.resolve()).then(function () {
          if (!CAM.arrancando) { camSoltar(); return; }
          CAM.arrancando = false; CAM.on = true;
          if (!S.estAb) { camApagar(); return; }
          camUI(true);
          try { var cap = CAM.track && CAM.track.getCapabilities ? CAM.track.getCapabilities() : {}; if (cap && cap.torch) $('jpm-torch').hidden = false; } catch (e) {}
          camCiclo();
        });
      }, function () { camFallo('No se pudo cargar el lector de c\u00f3digos: usa el l\u00e1ser o escribe el c\u00f3digo'); });
    }).catch(function (e) {
      var n = e && e.name;
      camFallo(n === 'NotAllowedError' || n === 'SecurityError' ? 'Sin permiso para la c\u00e1mara: act\u00edvalo en el candado de la barra del navegador y vuelve a tocar \ud83d\udcf7' :
        n === 'NotFoundError' || n === 'OverconstrainedError' ? 'No encontr\u00e9 una c\u00e1mara en este equipo' : null);
    });
  }
  function camCiclo() {
    if (!CAM.on) return;
    var v = CAM.video;
    var sig = function (ms) { clearTimeout(CAM.tm); CAM.tm = setTimeout(camCiclo, ms); };
    if (!v || v.readyState < 2 || !v.videoWidth) { sig(120); return; }
    CAM.n = (CAM.n || 0) + 1;
    /* con lector nativo: 2 de cada 3 cuadros van al nativo y 1 a ZXing "blanqueado" */
    if (CAM.det && (!CAM.zx || CAM.n % 3 !== 0)) {
      CAM.det.detect(v).then(function (cs) {
        if (!CAM.on) return;
        var val = cs && cs.length ? cs[0].rawValue : '';
        if (val) camLeido(val);
        sig(val ? 300 : 80);
      }).catch(function () { sig(300); });
      return;
    }
    /* ZXing: franja central (45% del alto) a resoluci\u00f3n real, tope 1920 px de ancho */
    var vw = v.videoWidth, vh = v.videoHeight;
    var bh = Math.round(vh * 0.45), by = Math.round((vh - bh) / 2);
    var k = Math.min(1, 1920 / vw);
    var cw = Math.round(vw * k), ch = Math.round(bh * k);
    if (CAM.cv.width !== cw) CAM.cv.width = cw;
    if (CAM.cv.height !== ch) CAM.cv.height = ch;
    var txt = '';
    try {
      CAM.ctx.drawImage(v, 0, by, vw, bh, 0, 0, cw, ch);
      var Z = window.ZXing, pasada = CAM.det ? 1 + ((CAM.n / 3) % 2) : CAM.n % 3;
      /* 1 de cada 3 cuadros se lee tal cual; los otros, "blanqueando" todo lo que
         no es barra: as\u00ed leen tambi\u00e9n las etiquetas viejas, impresas sin margen
         blanco alrededor del c\u00f3digo (sobre cart\u00f3n o fondo oscuro fallaban) */
      var fuente = pasada === 0 ? new Z.HTMLCanvasElementLuminanceSource(CAM.cv) : camNiveles(Z, cw, ch, pasada === 1 ? 0.3 : 0.45);
      txt = CAM.zx.decodeWithState(new Z.BinaryBitmap(new Z.HybridBinarizer(fuente))).getText();
    } catch (e) {}
    try { CAM.zx.reset(); } catch (e) {}
    if (txt) camLeido(txt);
    sig(txt ? 300 : 50);
  }
  function camNiveles(Z, w, h, f) {
    var d = CAM.ctx.getImageData(0, 0, w, h).data, n = w * h;
    if (!CAM.lum || CAM.lum.length !== n) CAM.lum = new Uint8ClampedArray(n);
    var lum = CAM.lum, hist = new Uint32Array(256), i, j;
    for (i = 0, j = 0; j < n; i += 4, j++) { var l = (d[i] * 77 + d[i + 1] * 150 + d[i + 2] * 29) >> 8; lum[j] = l; hist[l]++; }
    var acc = 0, lo = 0, hi = 255, a = n * 0.02, b = n * 0.98;
    for (i = 0; i < 256; i++) { acc += hist[i]; if (acc <= a) lo = i; if (acc < b) hi = i; }
    var t = lo + (hi - lo) * f;
    for (j = 0; j < n; j++) lum[j] = lum[j] < t ? 0 : 255;
    return new Z.RGBLuminanceSource(lum, w, h);
  }
  function camLeido(txt) {
    var w = $('jpm-camw');
    w.classList.remove('leido'); void w.offsetWidth; w.classList.add('leido');
    clearTimeout(CAM.tmL); CAM.tmL = setTimeout(function () { w.classList.remove('leido'); }, 450);
    leer(txt, 'cam');
  }
  function camLuz() {
    if (!CAM.on || !CAM.track) return;
    CAM.luz = !CAM.luz;
    CAM.track.applyConstraints({ advanced: [{ torch: CAM.luz }] }).catch(function () {});
    $('jpm-torch').setAttribute('aria-pressed', String(CAM.luz));
  }
  function camApagar() {
    CAM.arrancando = false; CAM.on = false;
    camSoltar();
    camUI(false);
  }

  /* L\u00e1ser: con la estaci\u00f3n abierta, toda r\u00e1faga de teclas es un c\u00f3digo
     (no hace falta tocar ning\u00fan campo). Se ignora solo el campo manual. */
  document.addEventListener('keydown', function (e) {
    if (!S.estAb) return;
    var tg = e.target;
    if (tg && tg.classList && tg.classList.contains('jpm-libre')) return;
    if (e.key === 'Escape') { e.preventDefault(); cerrarEst(); return; }
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (e.key === 'Enter' || e.key === 'Tab') {
      if (S.buf) { e.preventDefault(); var c = S.buf; S.buf = ''; clearTimeout(S.tm); leer(c, 'laser'); }
      return;
    }
    if (e.key === ' ' && !S.buf) return;
    if (e.key && e.key.length === 1) {
      e.preventDefault();
      var ah = Date.now();
      if (!S.buf || ah - S.tU > 1500) { S.buf = ''; S.t0 = ah; }
      S.buf += e.key; S.tU = ah;
      $('jpm-eco').textContent = 'Leyendo: ' + S.buf;
      clearTimeout(S.tm);
      /* l\u00e1ser sin Enter al final: si la r\u00e1faga fue r\u00e1pida, se procesa sola */
      S.tm = setTimeout(function () { var n = S.buf.length; if (n >= 6 && (S.tU - S.t0) / (n - 1) < 45) { var c2 = S.buf; S.buf = ''; leer(c2, 'laser'); } }, 220);
    }
  }, true);

  /* L\u00e1ser con la estaci\u00f3n CERRADA: si disparan en la p\u00e1gina (sin estar
     escribiendo en un campo), se abre la estaci\u00f3n y se procesa el c\u00f3digo. */
  document.addEventListener('keydown', function (e) {
    if (S.estAb || !SES || $('jpm-panel').hidden) return;
    if (!$('jpm-dlg').hidden || S.editando) return;
    var tg = e.target || {};
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(tg.tagName || '') || tg.isContentEditable) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    var ah = Date.now();
    if (e.key === 'Enter') {
      var n = S.pbuf.length, rapido = n >= 6 && (S.ptU - S.pt0) / (n - 1) < 45 && ah - S.ptU < 300;
      if (rapido) { e.preventDefault(); var c = S.pbuf; S.pbuf = ''; abrirEst(); leer(c, 'laser'); }
      S.pbuf = '';
      return;
    }
    if (e.key && e.key.length === 1) {
      if (!S.pbuf || ah - S.ptU > 300) { S.pbuf = ''; S.pt0 = ah; }
      S.pbuf += e.key; S.ptU = ah;
    }
  });

  /* --------- sesi\u00f3n --------- */
  function mostrarLogin(msg) {
    $('jpm-panel').hidden = true;
    $('jpm-login').hidden = false;
    if (msg) mostrarErr('jpm-l-msg', msg);
  }
  function abrirPanel() {
    $('jpm-login').hidden = true;
    $('jpm-panel').hidden = false;
    pintarCabecera();
    pintar();
    cargar();
  }
  function sesionVencida() {
    if (S.cola.length) S.cola = [];
    SES = null; P = []; RES = null;
    try { sessionStorage.removeItem('jpm_ses'); } catch (e) {}
    if (S.estAb) cerrarEst();
    if (S.abierto) cerrarDr();
    if (!$('jpm-dlg').hidden) cerrarRapida();
    mostrarLogin('Tu sesi\u00f3n del centro venci\u00f3. Entra de nuevo con tu c\u00f3digo y clave.');
  }
  function salir() {
    SES = null; P = []; RES = null;
    try { sessionStorage.removeItem('jpm_ses'); } catch (e) {}
    mostrarLogin('');
    mostrarErr('jpm-l-msg', '');
    window.scrollTo(0, 0);
  }
  function entrar(e) {
    e.preventDefault();
    var codigo = $('jpm-l-codigo').value.trim().toUpperCase(), clave = $('jpm-l-clave').value;
    if (!codigo || !clave) { mostrarErr('jpm-l-msg', 'Completa c\u00f3digo y clave.'); return; }
    var b = $('jpm-l-btn'); b.disabled = true; b.textContent = 'Entrando\u2026';
    mostrarErr('jpm-l-msg', '');
    api('master-login', { codigo: codigo, clave: clave, email_cuenta: EMAIL }, true).then(function (d) {
      b.disabled = false; b.textContent = 'Entrar';
      if (!d.ok) { mostrarErr('jpm-l-msg', d.error || 'No se pudo entrar.'); return; }
      var c = d.centro || {};
      SES = { codigo: codigo, clave: clave, id: c.id || '', nombre: c.nombre || codigo, ciudad: c.ciudad || '', tarifa: c.tarifa || 0, direccion: c.direccion || '', telefono: c.telefono || '' };
      try { sessionStorage.setItem('jpm_ses', JSON.stringify(SES)); } catch (x) {}
      $('jpm-l-clave').value = '';
      abrirPanel();
    }).catch(function () { b.disabled = false; b.textContent = 'Entrar'; mostrarErr('jpm-l-msg', 'Sin conexi\u00f3n. Intenta de nuevo.'); });
  }



  /* ========= 💸 YA TE PAGUÉ · rendición desde el portal (v3.3, 13-oct-2026) =========
     Dos pasos en el teléfono: (1) QUÉ pedidos (entregados / por entregar / todos,
     tarjetas grandes), (2) CUÁNTO (total o abono), comisión, moneda, método,
     referencia y FOTO. Llega a JBOXLY como "pendiente"; al aprobar, los pedidos
     quedan rendidos (si fue pago total de entregados) o baja la deuda por monto
     (abono / adelanto). Si la rechazan, aquí se ve el motivo. */
  var REND = [];
  var RD = { paso: 1, filtro: 'entregados', sel: {}, tipo: 'total', desc: true, metodo: 'binance', foto: null, enviando: false, sinPedidos: false };
  var RD_METODOS = [['binance', '🟡 Binance (USDT)'], ['zelle', '💜 Zelle'], ['pago_movil', '📱 Pago Móvil'], ['transferencia', '🏦 Transferencia'], ['efectivo', '💵 Efectivo / otro']];
  function rdCss() {
    if (document.getElementById('jpm-rd-css')) return;
    var st = document.createElement('style');
    st.id = 'jpm-rd-css';
    st.textContent =
      '#jpm-rd .jpm-dlg{display:flex;flex-direction:column;max-height:calc(100vh - 24px);overflow:hidden;}#jpm-rd .jpm-dlg-b{overflow:auto;flex:1;min-height:0;}' +
      '.jpm-rd-chips{display:flex;gap:8px;}.jpm-rd-chip{flex:1;min-height:44px;border-radius:12px;border:1px solid var(--jl2);background:var(--jr);color:var(--jt2);font-weight:700;font-size:13.5px;}.jpm-rd-chip[aria-pressed="true"]{border-color:var(--jo);background:var(--jos);color:#ffb877;font-weight:800;}' +
      '.jpm-rd-chip i{display:inline-block;min-width:20px;padding:1px 6px;border-radius:999px;background:var(--jl);font-style:normal;font-size:12px;margin-left:4px;}.jpm-rd-chip[aria-pressed="true"] i{background:var(--jo);color:var(--jink);}' +
      '.jpm-rd-top{display:flex;justify-content:space-between;align-items:center;font-size:12.5px;color:var(--jm);}.jpm-rd-top button{background:none;border:0;color:var(--jo);font-weight:800;font-size:13px;min-height:44px;}' +
      '.jpm-rd-list{display:grid;gap:10px;}.jpm-rd-sep{display:flex;align-items:center;gap:10px;font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;color:var(--jm);font-weight:700;padding-top:6px;}.jpm-rd-sep i{flex:1;height:1px;background:var(--jl);}' +
      '.jpm-rd-card{display:grid;grid-template-columns:30px minmax(0,1fr) auto;gap:12px;align-items:center;padding:14px;border-radius:14px;border:2px solid var(--jl);background:var(--jp);cursor:pointer;margin:0;}.jpm-rd-card.on{border-color:var(--jo);background:var(--jos);}' +
      '.jpm-rd-card input{width:26px;height:26px;margin:0;accent-color:var(--jo);}.jpm-rd-card .n{display:block;font-size:17px;font-weight:800;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.jpm-rd-card .e{display:block;font-size:12.5px;color:var(--jt2);margin-top:2px;}.jpm-rd-card .c{display:block;font-size:12px;color:var(--jm);margin-top:2px;}.jpm-rd-card .m{font-size:20px;font-weight:900;color:#fff;font-variant-numeric:tabular-nums;}' +
      '.jpm-rd-card.rev{opacity:.55;cursor:default;}' +
      '.jpm-rd-foot{display:flex;flex-direction:column;gap:10px;padding:12px 18px 14px;border-top:1px solid var(--jl);background:var(--jp);}.jpm-rd-foot .r{display:flex;justify-content:space-between;align-items:baseline;font-size:13.5px;color:var(--jt2);}.jpm-rd-foot .r>b{font-size:22px;font-weight:900;color:#fff;font-variant-numeric:tabular-nums;}.jpm-rd-foot .r>b.ok{color:var(--jok);}' +
      '.jpm-rd-foot .bs{display:flex;gap:10px;}.jpm-rd-foot .bs .jpm-btn{flex:1;min-height:50px;font-size:14px!important;}.jpm-rd-foot .bs .jpm-pri{flex:1.4;font-size:15px!important;font-weight:900;}' +
      '.jpm-rd-h{font-size:12px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:var(--jm);margin-bottom:8px;}' +
      '.jpm-rd-tipo{display:grid;grid-template-columns:1fr 1fr;gap:10px;}.jpm-rd-tipo label{display:flex;flex-direction:column;gap:4px;padding:14px;border-radius:14px;border:2px solid var(--jl);background:var(--jp);cursor:pointer;margin:0;}.jpm-rd-tipo label.on{border-color:var(--jo);background:var(--jos);}' +
      '.jpm-rd-tipo input{width:22px;height:22px;margin:0;accent-color:var(--jo);}.jpm-rd-tipo .t{display:flex;align-items:center;gap:8px;font-size:16px;font-weight:900;color:#fff;}.jpm-rd-tipo .s{font-size:12.5px;color:var(--jt2);}.jpm-rd-tipo .v{font-size:22px;font-weight:900;color:#fff;font-variant-numeric:tabular-nums;}.jpm-rd-tipo .v.off{color:#55555f;}' +
      '.jpm-rd-com{display:grid;grid-template-columns:26px minmax(0,1fr) auto;gap:10px;align-items:center;padding:12px 14px;border-radius:14px;border:1px solid var(--jl2);background:var(--jp);cursor:pointer;margin:0;}.jpm-rd-com input{width:22px;height:22px;margin:0;accent-color:var(--jo);}.jpm-rd-com .t{display:block;font-size:14.5px;font-weight:800;color:#fff;}.jpm-rd-com .s{display:block;font-size:12px;color:var(--jm);}.jpm-rd-com b{font-size:15px;font-weight:900;color:var(--jok);font-variant-numeric:tabular-nums;}' +
      '.jpm-rd-monto{display:grid;grid-template-columns:110px minmax(0,1fr);gap:10px;}.jpm-rd-monto select,.jpm-rd-monto input,.jpm-rd-in{min-height:52px;border-radius:12px;border:1px solid var(--jl2)!important;background:var(--jb)!important;color:#fff!important;-webkit-text-fill-color:#fff;font-size:15px;padding:0 12px;box-sizing:border-box;width:100%;margin:0;height:auto;outline:none;}' +
      '.jpm-rd-monto input{border:2px solid var(--jo)!important;font-size:24px;font-weight:900;font-variant-numeric:tabular-nums;}.jpm-rd-in::placeholder,.jpm-rd-monto input::placeholder{color:#6e6e7a;-webkit-text-fill-color:#6e6e7a;}' +
      '.jpm-rd-met{display:grid;grid-template-columns:1fr 1fr;gap:10px;}.jpm-rd-met button{min-height:52px;border-radius:12px;border:2px solid var(--jl);background:var(--jp);color:var(--jt2);font-weight:700;font-size:14.5px;}.jpm-rd-met button[aria-pressed="true"]{border-color:var(--jo);background:var(--jos);color:#fff;font-weight:800;}' +
      '.jpm-rd-fotob{width:100%;min-height:64px;border-radius:14px;border:2px dashed var(--jo);background:rgba(254,121,5,.06);color:#ffb877;font-weight:800;font-size:15px;display:flex;align-items:center;justify-content:center;gap:10px;cursor:pointer;}.jpm-rd-fotob img{width:48px;height:48px;object-fit:cover;border-radius:8px;border:1px solid var(--jl2);background:#000;}#jpm-rd-file{display:none;}' +
      '.jpm-rd-nota{font-size:12px;color:var(--jm);margin-top:6px;}' +
      '.jpm-cta{display:grid;gap:8px;}.jpm-cta .f{display:flex;justify-content:space-between;gap:10px;font-size:13.5px;color:var(--jt2);padding:7px 0;border-bottom:1px solid #1f1f28;}.jpm-cta .f small{display:block;color:var(--jm);font-size:11.5px;}.jpm-cta .f b{font-variant-numeric:tabular-nums;white-space:nowrap;}' +
      '.jpm-rd-btn{width:100%;min-height:54px;margin-top:8px;font-size:16px!important;font-weight:900;}' +
      '.jpm-rd-hist{display:grid;gap:8px;margin-top:10px;}.jpm-rd-it{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;align-items:start;background:var(--jp);border:1px solid var(--jl);border-left:4px solid var(--c);border-radius:12px;padding:10px 12px;font-size:12.5px;color:var(--jt2);}.jpm-rd-it .a{font-size:15px;font-weight:800;color:#fff;}.jpm-rd-it .d{color:var(--jm);font-size:12px;}.jpm-rd-it .x{color:var(--jbad);font-size:12px;}' +
      '.jpm-rd-est{display:inline-block;border-radius:999px;padding:4px 10px;font-size:12px;font-weight:800;white-space:nowrap;background:color-mix(in srgb,var(--c) 17%,transparent);color:var(--c);}';
    document.head.appendChild(st);
  }
  function rdPendIds() { var ids = {}; REND.forEach(function (r) { if (r.estado === 'pendiente') (r.pedidos || []).forEach(function (id) { ids[id] = 1; }); }); return ids; }
  function rdEstadoDe(p) { /* etapa de un pedido para la cuenta y el diálogo */
    var e = etapa(p);
    return e === 'cliente' ? 'entregado' : e === 'centro' ? 'centro' : e === 'camino' ? 'camino' : e === 'compra' ? 'compra' : 'otro';
  }
  /* COD vivo: todo lo que el centro debe o deberá, por etapa (sin rendidos ni cancelados) */
  function rdDeuda() {
    var r = { entregado: { n: 0, m: 0 }, centro: { n: 0, m: 0 }, camino: { n: 0, m: 0 }, compra: { n: 0, m: 0 } };
    P.forEach(function (p) {
      if (p.met !== 'cod' || p.rendido || p.cobrar <= 0) return;
      var k = rdEstadoDe(p); if (!r[k]) return;
      r[k].n++; r[k].m += p.cobrar;
    });
    Object.keys(r).forEach(function (k) { r[k].m = Math.round(r[k].m * 100) / 100; });
    return r;
  }
  function rdElegibles(filtro) {
    var pend = rdPendIds();
    return P.filter(function (p) {
      if (p.met !== 'cod' || p.rendido || p.cobrar <= 0 || p.st === 'cancelada') return false;
      var k = rdEstadoDe(p);
      if (k === 'otro') return false;
      if (filtro === 'entregados') return k === 'entregado';
      if (filtro === 'por_entregar') return k !== 'entregado';
      return true;
    }).map(function (p) { p._rev = !!pend[p.id]; return p; })
      .sort(function (a, b) { var ka = rdEstadoDe(a) === 'entregado' ? 0 : 1, kb = rdEstadoDe(b) === 'entregado' ? 0 : 1; if (ka !== kb) return ka - kb; return tiempo(a) - tiempo(b); });
  }
  function rdMetodoTxt(k) { for (var i = 0; i < RD_METODOS.length; i++) if (RD_METODOS[i][0] === k) return RD_METODOS[i][1].replace(/^\S+\s/, ''); return k === 'otro' ? 'Otro' : (k || ''); }
  function rdEtapaTxt(p) {
    var k = rdEstadoDe(p);
    if (k === 'entregado') return '🏁 Entregado el ' + fcorta((p.ent || {}).fecha);
    if (k === 'centro') return '🏬 En tu centro, por entregar';
    if (k === 'camino') return '✈️ En camino' + (p.caja ? ' · caja ' + p.caja : '');
    return '🛒 ' + (p.st === 'comprado' ? 'Comprado, viene a Dallas' : 'En compra');
  }
  function pintarRendHist() {
    if (!REND.length) return '';
    var pend = REND.filter(function (r) { return r.estado === 'pendiente'; });
    var ALC = { entregados: 'pedidos entregados', por_entregar: 'pedidos por entregar', mixto: 'entregados y por entregar', monto: 'sin pedidos marcados' };
    return '<div class="jpm-up" style="margin-top:14px">Tus pagos enviados' + (pend.length ? ' · <span style="color:var(--jw)">' + plural(pend.length, 'en revisión', 'en revisión') + '</span>' : '') + '</div><div class="jpm-rd-hist">' +
      REND.slice(0, 8).map(function (r) {
        var col = r.estado === 'aprobada' ? 'var(--jok)' : r.estado === 'rechazada' ? 'var(--jbad)' : 'var(--jw)';
        var txt = r.estado === 'aprobada' ? '✅ Aprobado' : r.estado === 'rechazada' ? '✖ Rechazado' : '⏳ En revisión';
        var peds = r.pedidos || [];
        var nombres = peds.map(function (id) { var p = byId(id); return p ? primer(p.cli) : id; }).slice(0, 3).join(', ') + (peds.length > 3 ? '…' : '');
        return '<div class="jpm-rd-it" style="--c:' + col + '"><div><div class="a">' + (r.moneda === 'BS' ? Number(r.monto_original).toLocaleString('es-VE') + ' Bs (≈ ' + din(r.monto_usd) + ')' : din(r.monto_usd)) + ' · ' + esc(rdMetodoTxt(r.metodo)) + '</div>' +
          '<div>' + esc(fcorta(r.creado)) + ' · ' + (r.tipo === 'abono' ? 'abono' : 'pago total') + ' · ' + (peds.length ? plural(peds.length, 'pedido', 'pedidos') + ' (' + esc(nombres) + ')' : esc(ALC[r.alcance] || 'sin pedidos marcados')) + '</div>' +
          '<div class="d">' + (r.referencia ? 'Ref ' + esc(r.referencia) + ' · ' : '') + (r.comprobante ? '🧾 con comprobante' : 'sin foto') + '</div>' +
          (r.estado === 'rechazada' && r.motivo ? '<div class="x">Motivo: ' + esc(r.motivo) + ' · vuelve a enviarlo corregido</div>' : '') +
          '</div><span class="jpm-rd-est" style="--c:' + col + '">' + txt + '</span></div>';
      }).join('') + '</div>';
  }

  /* ---- diálogo en 2 pasos ---- */
  function rdCapa() {
    var el = $('jpm-rd');
    if (!el) { el = document.createElement('div'); el.className = 'jpm-capa jpm-ov'; el.id = 'jpm-rd'; el.hidden = true; document.body.appendChild(el); }
    return el;
  }
  function abrirRendir() {
    if (!SES) return;
    rdCss();
    RD.paso = 1; RD.sel = {}; RD.tipo = 'total'; RD.desc = true; RD.metodo = 'binance'; RD.foto = null; RD.enviando = false; RD.sinPedidos = false;
    RD.filtro = rdElegibles('entregados').some(function (p) { return !p._rev; }) ? 'entregados' : (rdElegibles('por_entregar').length ? 'por_entregar' : 'todos');
    rdElegibles(RD.filtro).forEach(function (p) { if (!p._rev && rdEstadoDe(p) === 'entregado') RD.sel[p.id] = 1; });
    rdCapa().hidden = false; lock(true);
    rdPintar();
  }
  function cerrarRendir() { var el = $('jpm-rd'); if (el) el.hidden = true; RD.foto = null; if (!capasAbiertas()) lock(false); }
  function rdSelec() { return P.filter(function (p) { return RD.sel[p.id]; }); }
  function rdResumenSel() {
    var sel = rdSelec(), suma = 0, com = 0, ent = 0, noEnt = 0;
    sel.forEach(function (p) { suma += p.cobrar; if (rdEstadoDe(p) === 'entregado') { ent++; com += p.com; } else noEnt++; });
    return { n: sel.length, suma: Math.round(suma * 100) / 100, com: Math.round(com * 100) / 100, ent: ent, noEnt: noEnt, alcance: !sel.length ? 'monto' : noEnt && ent ? 'mixto' : ent ? 'entregados' : 'por_entregar' };
  }
  function rdCalc() {
    var R = rdResumenSel();
    var desc = RD.desc && R.ent > 0;
    var esperado = Math.round((R.suma - (desc ? R.com : 0)) * 100) / 100;
    var moneda = ($('jpm-rd-moneda') || {}).value === 'BS' ? 'BS' : 'USD';
    var monto = RD.tipo === 'total' && moneda === 'USD' ? esperado : num(($('jpm-rd-monto') || {}).value);
    var tasa = num(($('jpm-rd-tasa') || {}).value);
    var usd = moneda === 'BS' ? (monto > 0 && tasa > 0 ? Math.round(monto / tasa * 100) / 100 : 0) : monto;
    return { R: R, desc: desc, esperado: esperado, moneda: moneda, monto: monto, tasa: tasa, usd: usd };
  }
  function rdPintar() {
    var el = rdCapa();
    if (RD.paso === 1) rdPintar1(el); else rdPintar2(el);
  }
  function rdPintar1(el) {
    var lista = rdElegibles(RD.filtro);
    var nEnt = rdElegibles('entregados').length, nPor = rdElegibles('por_entregar').length;
    var chip = function (k, t, n) { return '<button type="button" class="jpm-rd-chip" data-jpm="rd-filtro" data-k="' + k + '" aria-pressed="' + (RD.filtro === k) + '">' + t + (n != null ? ' <i>' + n + '</i>' : '') + '</button>'; };
    var cards = '', ultimo = '';
    lista.forEach(function (p) {
      var k = rdEstadoDe(p) === 'entregado' ? 'ent' : 'por';
      if (RD.filtro === 'todos' && k !== ultimo) { cards += '<div class="jpm-rd-sep"><i></i>' + (k === 'ent' ? 'Entregados · debes ya' : 'Por entregar · pago adelantado') + '<i></i></div>'; ultimo = k; }
      var on = !!RD.sel[p.id];
      cards += '<label class="jpm-rd-card' + (on ? ' on' : '') + (p._rev ? ' rev' : '') + '"><input type="checkbox" class="jpm-rd-chk" value="' + esc(p.id) + '"' + (on ? ' checked' : '') + (p._rev ? ' disabled' : '') + '>' +
        '<span style="min-width:0"><span class="n">' + esc(p.cli) + '</span><span class="e">' + esc(rdEtapaTxt(p)) + ' · ' + esc(p.id) + '</span><span class="c">' +
        (p._rev ? '⏳ Ya enviado, en revisión' : rdEstadoDe(p) === 'entregado' ? 'Tu comisión: ' + din(p.com) + (p.abonado ? ' · ya abonó ' + din(p.abonado) : '') : 'Cobras al entregar ' + din(p.cobrar)) + '</span></span>' +
        '<span class="m"' + (rdEstadoDe(p) !== 'entregado' ? ' style="color:var(--jt2)"' : '') + '>' + din(p.cobrar) + '</span></label>';
    });
    var R = rdResumenSel();
    el.innerHTML = '<form class="jpm-dlg" id="jpm-f-rd1" novalidate role="dialog" aria-modal="true" aria-labelledby="jpm-rd-t">' +
      '<div class="jpm-dlg-h"><div><div class="jpm-up" style="color:var(--jo)">Paso 1 de 2</div><h2 id="jpm-rd-t">¿Qué pedidos estás pagando?</h2></div><button type="button" class="jpm-x" data-jpm="cerrar-rd" aria-label="Cerrar">×</button></div>' +
      '<div class="jpm-dlg-b">' +
      '<div class="jpm-rd-chips">' + chip('entregados', '🏁 Entregados', nEnt) + chip('por_entregar', '📦 Por entregar', nPor) + chip('todos', 'Todos', null) + '</div>' +
      '<div class="jpm-rd-top"><span>' + (RD.filtro === 'entregados' ? 'Cobraste a tus clientes y aún no rindes' : RD.filtro === 'por_entregar' ? 'Aún no entregas: sería un pago adelantado' : 'Todo lo que debes o deberás') + '</span><button type="button" data-jpm="rd-todos">' + (lista.length && lista.every(function (p) { return p._rev || RD.sel[p.id]; }) ? 'Desmarcar' : 'Marcar todos') + '</button></div>' +
      (lista.length ? '<div class="jpm-rd-list">' + cards + '</div>' : '<div class="jpm-nota" style="padding:20px 0;text-align:center">Nada aquí todavía.</div>') +
      '</div>' +
      '<div class="jpm-rd-foot"><div class="r"><span>' + (R.n ? plural(R.n, 'pedido marcado', 'pedidos marcados') : 'Ningún pedido marcado') + '</span><b>' + din(R.suma) + '</b></div>' +
      '<div class="bs"><button type="button" class="jpm-btn" data-jpm="rd-sin">Pagar sin elegir pedidos</button><button type="button" class="jpm-btn jpm-pri" data-jpm="rd-sig"' + (R.n ? '' : ' disabled') + '>Continuar →</button></div></div></form>';
  }
  function rdPintar2(el) {
    var R = rdResumenSel();
    var desc = RD.desc && R.ent > 0;
    var esperado = Math.round((R.suma - (desc ? R.com : 0)) * 100) / 100;
    var cab = R.n ? plural(R.n, 'pedido', 'pedidos') + ' · ' + din(R.suma) : 'Sin pedidos marcados';
    el.innerHTML = '<form class="jpm-dlg" id="jpm-f-rd" novalidate role="dialog" aria-modal="true" aria-labelledby="jpm-rd-t2">' +
      '<div class="jpm-dlg-h"><div style="display:flex;gap:10px;align-items:flex-start"><button type="button" class="jpm-btn jpm-sm" data-jpm="rd-atras" aria-label="Volver" style="min-width:44px;min-height:44px">←</button><div><div class="jpm-up" style="color:var(--jo)">Paso 2 de 2 · ' + esc(cab) + '</div><h2 id="jpm-rd-t2">¿Cuánto envías y por dónde?</h2></div></div><button type="button" class="jpm-x" data-jpm="cerrar-rd" aria-label="Cerrar">×</button></div>' +
      '<div class="jpm-dlg-b">' +
      (R.n ? '<div><div class="jpm-rd-h">¿Pagas todo o una parte?</div><div class="jpm-rd-tipo">' +
        '<label class="' + (RD.tipo === 'total' ? 'on' : '') + '"><span class="t"><input type="radio" name="jpm-rd-tipo" value="total"' + (RD.tipo === 'total' ? ' checked' : '') + '> Total</span><span class="s">Lo de los pedidos marcados</span><span class="v">' + din(esperado) + '</span></label>' +
        '<label class="' + (RD.tipo === 'abono' ? 'on' : '') + '"><span class="t"><input type="radio" name="jpm-rd-tipo" value="abono"' + (RD.tipo === 'abono' ? ' checked' : '') + '> Abono</span><span class="s">Una parte; el resto queda pendiente</span><span class="v' + (RD.tipo === 'abono' ? '' : ' off') + '">$ ___</span></label></div></div>' : '<div class="jpm-nota">Pago por monto: JBOXLY lo descuenta de lo que debes, sin marcar pedidos.</div>') +
      (R.ent ? '<label class="jpm-rd-com"><input type="checkbox" id="jpm-rd-desc"' + (RD.desc ? ' checked' : '') + '><span><span class="t">Ya me desconté mi comisión</span><span class="s">' + plural(R.ent, 'entrega', 'entregas') + ' · ' + din(R.com) + '. Si lo desmarcas, mandas el total y JBOXLY te la paga aparte.</span></span><b>−' + din(R.com) + '</b></label>' : '') +
      '<div><div class="jpm-rd-h">Monto que enviaste</div><div class="jpm-rd-monto"><select id="jpm-rd-moneda" aria-label="Moneda"><option value="USD">USD</option><option value="BS">Bs</option></select><input id="jpm-rd-monto" inputmode="decimal" autocomplete="off" placeholder="0.00" aria-label="Monto"' + (RD.tipo === 'total' ? ' value="' + esperado.toFixed(2) + '"' : '') + '></div>' +
      '<div id="jpm-rd-tasa-w" hidden style="margin-top:10px"><div class="jpm-rd-h">Tasa (Bs por dólar)</div><input class="jpm-rd-in" id="jpm-rd-tasa" inputmode="decimal" autocomplete="off" placeholder="Ej: 40.00"><div class="jpm-rd-nota" id="jpm-rd-equiv"></div></div>' +
      '<div class="jpm-rd-nota" id="jpm-rd-aviso"></div></div>' +
      '<div><div class="jpm-rd-h">¿Por dónde lo mandaste?</div><div class="jpm-rd-met">' + RD_METODOS.map(function (m) { return '<button type="button" data-jpm="rd-metodo" data-k="' + m[0] + '" aria-pressed="' + (RD.metodo === m[0]) + '">' + m[1] + '</button>'; }).join('') + '</div></div>' +
      '<div><label class="jpm-rd-h" for="jpm-rd-ref" style="display:block">Referencia de la transferencia</label><input class="jpm-rd-in" id="jpm-rd-ref" autocomplete="off" placeholder="Número de operación (opcional)"></div>' +
      '<div><div class="jpm-rd-h">Foto del comprobante</div><label class="jpm-rd-fotob" for="jpm-rd-file" id="jpm-rd-fotol">' + (RD.foto ? '<img src="' + RD.foto.base64 + '" alt=""> ✓ Foto lista · toca para cambiarla' : '📷 Tomar foto o elegir captura') + '</label><input type="file" id="jpm-rd-file" accept="image/*" capture="environment"><div class="jpm-rd-nota" id="jpm-rd-foto-t">Con comprobante se aprueba más rápido. Se comprime sola.</div></div>' +
      '<div><label class="jpm-rd-h" for="jpm-rd-nota" style="display:block">Nota (opcional)</label><input class="jpm-rd-in" id="jpm-rd-nota" autocomplete="off" placeholder="Quién transfirió, acuerdo, diferencia…"></div>' +
      '<div class="jpm-err" id="jpm-rd-err" role="alert" hidden></div></div>' +
      '<div class="jpm-rd-foot"><div class="r"><span id="jpm-rd-res"></span><b class="ok" id="jpm-rd-tot"></b></div><button type="submit" class="jpm-btn jpm-pri" id="jpm-rd-btn" style="min-height:54px;font-size:16px!important;font-weight:900">Enviar a JBOXLY</button></div></form>';
    rdPrev();
    setTimeout(function () { var i = $('jpm-rd-monto'); if (i && RD.tipo === 'abono') i.focus(); }, 50);
  }
  function rdPrev() {
    var c = rdCalc();
    var tw = $('jpm-rd-tasa-w'); if (tw) tw.hidden = c.moneda !== 'BS';
    var eq = $('jpm-rd-equiv'); if (eq) eq.textContent = c.moneda === 'BS' && c.usd ? '= ' + din(c.usd) : '';
    var mi = $('jpm-rd-monto');
    if (mi && RD.tipo === 'total' && c.moneda === 'USD') mi.value = c.esperado.toFixed(2);
    var av = $('jpm-rd-aviso');
    if (av) av.textContent = RD.tipo === 'abono' && c.R.n && c.usd > 0 ? 'Quedan pendientes ' + din(Math.max(0, c.esperado - c.usd)) + ' de estos pedidos.' : (RD.tipo === 'total' && c.moneda === 'BS' ? 'Escribe lo que enviaste en Bs y la tasa; debe equivaler a ' + din(c.esperado) + '.' : '');
    var res = $('jpm-rd-res'), tot = $('jpm-rd-tot');
    if (res) res.innerHTML = 'Envías por <b style="color:#fff">' + esc(rdMetodoTxt(RD.metodo)) + '</b> · ' + (c.R.n ? (RD.tipo === 'abono' ? 'abono' : 'pago total') + ' de ' + plural(c.R.n, 'pedido', 'pedidos') : 'pago por monto');
    if (tot) tot.textContent = c.usd > 0 ? din(c.usd) : (c.moneda === 'BS' && c.monto > 0 ? c.monto.toLocaleString('es-VE') + ' Bs' : '$ —');
  }
  function rdFoto(file) {
    if (!file) return;
    var t = $('jpm-rd-foto-t'); if (t) t.textContent = 'Preparando foto…';
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      try {
        var k = Math.min(1, 1400 / Math.max(img.naturalWidth, img.naturalHeight));
        var cv = document.createElement('canvas');
        cv.width = Math.round(img.naturalWidth * k); cv.height = Math.round(img.naturalHeight * k);
        cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
        var data = cv.toDataURL('image/jpeg', 0.78);
        if (data.length > 3000000) data = cv.toDataURL('image/jpeg', 0.55);
        RD.foto = { base64: data, tipo: 'image/jpeg' };
        var l = $('jpm-rd-fotol'); if (l) { l.innerHTML = '<img src="' + data + '" alt=""> ✓ Foto lista · toca para cambiarla'; }
        if (t) t.textContent = Math.round(data.length * 0.75 / 1024) + ' KB · lista para enviar.';
      } catch (e) { RD.foto = null; if (t) t.textContent = 'No se pudo leer la foto: intenta con otra.'; }
      URL.revokeObjectURL(url);
    };
    img.onerror = function () { URL.revokeObjectURL(url); RD.foto = null; if (t) t.textContent = 'Ese archivo no es una imagen.'; };
    img.src = url;
  }
  function enviarRendir(e) {
    e.preventDefault();
    if (RD.enviando) return;
    var c = rdCalc();
    var err = '';
    if (!(c.monto > 0)) err = 'Escribe el monto que enviaste.';
    else if (c.moneda === 'BS' && !(c.tasa > 0)) err = 'Escribe la tasa (Bs por dólar).';
    else if (RD.tipo === 'abono' && c.R.n && c.usd >= c.esperado - 0.009) err = 'Ese monto cubre el total: elige "Total" o baja el abono.';
    mostrarErr('jpm-rd-err', err);
    if (err) return;
    if (!RD.foto && !window.confirm('¿Enviar sin foto del comprobante?\n\nJBOXLY tendrá que verificarlo a mano y tardará más.')) return;
    RD.enviando = true;
    var b = $('jpm-rd-btn'); b.disabled = true; b.textContent = 'Enviando…';
    var pedidos = Object.keys(RD.sel);
    api('master-rendir', {
      pedidos: pedidos, tipo: c.R.n ? RD.tipo : 'abono', alcance: c.R.alcance, comision: c.desc ? c.R.com : 0,
      monto: c.monto, moneda: c.moneda, tasa: c.tasa, metodo: RD.metodo,
      referencia: ($('jpm-rd-ref') || {}).value || '', nota: (($('jpm-rd-nota') || {}).value || '') + (c.R.ent && !c.desc ? ' [sin descontar comisión]' : ''), foto: RD.foto
    }).then(function (d) {
      RD.enviando = false; b.disabled = false; b.textContent = 'Enviar a JBOXLY';
      if (!d.ok) { mostrarErr('jpm-rd-err', d.error || 'No se pudo enviar.'); return; }
      cerrarRendir();
      toast(d.repetida ? '⏳ Ese pago ya estaba enviado y en revisión' : '✅ Enviado: JBOXLY lo revisa y te confirma' + (d.aviso ? ' · ' + d.aviso : ''));
      cargar(true);
    }).catch(function () {
      RD.enviando = false; b.disabled = false; b.textContent = 'Enviar a JBOXLY';
      mostrarErr('jpm-rd-err', 'Sin conexión: NO se envió. Intenta de nuevo.');
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest || !t.closest('#jpm-rd')) return;
    if (t.id === 'jpm-rd-file') { rdFoto(t.files && t.files[0]); return; }
    if (t.classList && t.classList.contains('jpm-rd-chk')) { if (t.checked) RD.sel[t.value] = 1; else delete RD.sel[t.value]; rdPintar(); return; }
    if (t.name === 'jpm-rd-tipo') { RD.tipo = t.value === 'abono' ? 'abono' : 'total'; var mi = $('jpm-rd-monto'); if (mi && RD.tipo === 'abono') mi.value = ''; rdPintar(); return; }
    if (t.id === 'jpm-rd-desc') { RD.desc = !!t.checked; var m2 = $('jpm-rd-monto'); if (m2 && RD.tipo === 'total') m2.value = ''; rdPrev(); return; }
    rdPrev();
  });
  document.addEventListener('input', function (e) { var t = e.target; if (t && t.closest && t.closest('#jpm-rd') && t.tagName === 'INPUT') { if (t.id === 'jpm-rd-monto' && RD.tipo === 'total') { RD.tipo = 'abono'; rdPintar2(rdCapa()); var mi = $('jpm-rd-monto'); if (mi) { mi.value = t.value; mi.focus(); } } rdPrev(); } });
  function rdAccion(a, k) {
    if (a === 'rd-filtro') { RD.filtro = k; rdPintar(); return true; }
    if (a === 'rd-todos') { var l = rdElegibles(RD.filtro).filter(function (p) { return !p._rev; }); var todos = l.length && l.every(function (p) { return RD.sel[p.id]; }); l.forEach(function (p) { if (todos) delete RD.sel[p.id]; else RD.sel[p.id] = 1; }); rdPintar(); return true; }
    if (a === 'rd-sin') { RD.sel = {}; RD.tipo = 'abono'; RD.paso = 2; rdPintar(); return true; }
    if (a === 'rd-sig') { if (!Object.keys(RD.sel).length) return true; RD.tipo = 'total'; RD.paso = 2; rdPintar(); return true; }
    if (a === 'rd-atras') { RD.paso = 1; rdPintar(); return true; }
    if (a === 'rd-metodo') { RD.metodo = k; document.querySelectorAll('#jpm-rd [data-jpm="rd-metodo"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-k') === k)); }); rdPrev(); return true; }
    return false;
  }

  /* --------- eventos --------- */
  document.addEventListener('click', function (e) {
    var menu = $('jpm-menu');
    if (menu && !menu.hidden && !(e.target.closest && e.target.closest('.jpm-nuevo'))) { menu.hidden = true; $('jpm-menu-btn').setAttribute('aria-expanded', 'false'); }
    if (e.target === $('jpm-dlg')) { cerrarRapida(); return; }
    if (e.target === $('jpm-rd')) { cerrarRendir(); return; }
    var t = e.target.closest ? e.target.closest('[data-jpm]') : null;
    if (!t) return;
    if (!ROOT.contains(t) && !(t.closest && t.closest('.jpm-capa'))) return;
    var a = t.getAttribute('data-jpm'), k = t.getAttribute('data-k') || '';
    switch (a) {
      case 'menu': menu.hidden = !menu.hidden; t.setAttribute('aria-expanded', String(!menu.hidden)); return;
      case 'rapida': menu.hidden = true; abrirRapida(); return;
      case 'recargar': cargar(); return;
      case 'salir': salir(); return;
      case 'etapa': S.etapa = S.etapa === k ? '' : k; S.hoy = ''; pintar(); return;
      case 'hoy': S.hoy = S.hoy === k ? '' : k; S.etapa = ''; pintar(); return;
      case 'orig': S.orig = k; pintar(); return;
      case 'pago': S.pago = k; pintar(); return;
      case 'quitar': if (k === 'q') { S.q = ''; $('jpm-q').value = ''; } else S[k] = ''; pintar(); return;
      case 'ver': abrirDr(k); return;
      case 'cerrar-dr': cerrarDr(); return;
      case 'entregar': S.conf = k; pintarDrawer(); return;
      case 'entregar-no': S.conf = null; pintarDrawer(); return;
      case 'entregar-ok': entregar(k); return;
      case 'editar': S.editando = k; S.conf = null; pintarDrawer(); var f = $('jpm-e-nom'); if (f) f.focus(); return;
      case 'edit-no': S.editando = null; pintarDrawer(); return;
      case 'cerrar-dlg': cerrarRapida(); return;
      case 'add-it': { var cont = $(k); if (cont) { cont.insertAdjacentHTML('beforeend', filaItem()); var ins = cont.querySelectorAll('.jpm-itrow'); ins[ins.length - 1].querySelector('input').focus(); } return; }
      case 'del-it': {
        var row = t.closest('.jpm-itrow'), box = row && row.parentNode;
        if (box && box.querySelectorAll('.jpm-itrow').length > 1) row.remove(); else if (row) row.querySelectorAll('input').forEach(function (i, n) { i.value = n === 2 ? '1' : ''; });
        if (box) actualizarTot(box.id);
        return;
      }
      case 'pick': {
        var c = CLI_RES[parseInt(k, 10)];
        if (!c) return;
        $('jpm-r-nom').value = c.cli; $('jpm-r-tel').value = c.tel; $('jpm-r-em').value = c.em; $('jpm-r-dir').value = c.dir; $('jpm-r-cli').value = c.cli;
        $('jpm-r-res').innerHTML = '<div class="jpm-okt">\u2713 Datos de ' + esc(c.cli) + ' cargados de su \u00faltimo pedido</div>';
        var pi = document.querySelector('#jpm-r-items input'); if (pi) pi.focus();
        return;
      }
      case 'rendir': abrirRendir(); return;
      case 'cerrar-rd': cerrarRendir(); return;
      case 'rd-filtro': case 'rd-todos': case 'rd-sin': case 'rd-sig': case 'rd-atras': case 'rd-metodo': rdAccion(a, k); return;
      case 'est': abrirEst(); return;
      case 'est-cerrar': cerrarEst(); return;
      case 'modo': modo(k); return;
      case 'cam': camToggle(); t.blur(); return;
      case 'torch': camLuz(); t.blur(); return;
      case 'est-ok': t.blur(); confirmarEst(k); return;
    }
  });
  function actualizarTot(contId) {
    var tot = totDe(contId);
    var el = contId === 'jpm-r-items' ? $('jpm-r-tot') : $('jpm-e-tot');
    if (el) el.textContent = din(tot);
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.id === 'jpm-r-cli') { buscarCliente(); return; }
    var box = t.closest('.jpm-items');
    if (box) actualizarTot(box.id);
  });
  document.addEventListener('submit', function (e) {
    var id = e.target && e.target.id;
    if (id === 'jpm-f-login') entrar(e);
    else if (id === 'jpm-f-rapida') crearPedido(e);
    else if (id === 'jpm-f-edit') guardarEdicion(e);
    else if (id === 'jpm-f-rd') enviarRendir(e);
    else if (id === 'jpm-f-rd1') { e.preventDefault(); rdAccion('rd-sig'); }
    else if (id === 'jpm-f-man') { e.preventDefault(); var i = $('jpm-man'); var v = i.value; i.value = ''; i.blur(); leer(v, 'mano'); }
  });
  document.addEventListener('keydown', function (e) {
    if (S.estAb) return;
    if (e.key === 'Escape') {
      if ($('jpm-rd') && !$('jpm-rd').hidden) { cerrarRendir(); return; }
      if (!$('jpm-dlg').hidden) { cerrarRapida(); return; }
      if (S.editando) { S.editando = null; pintarDrawer(); return; }
      if (S.abierto) { cerrarDr(); return; }
      var menu = $('jpm-menu'); if (menu && !menu.hidden) menu.hidden = true;
      return;
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList && e.target.classList.contains('jpm-row') && !e.target.classList.contains('hd')) {
      e.preventDefault(); abrirDr(e.target.getAttribute('data-k'));
    }
  });
  var qT;
  $('jpm-q').addEventListener('input', function () {
    clearTimeout(qT); var v = this.value;
    qT = setTimeout(function () { S.q = v.trim(); pintar(); }, 120);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && SES && Date.now() - CARGADO > 120000) cargar(true);
  });

  /* --------- arranque --------- */
  if (SES) abrirPanel(); else mostrarLogin('');
})();